export default [
  {
    id: "1",
    name: "Mumbai",
    state: "Maharashtra",
    lat: 19.076,
    lng: 72.8777,
  },
  {
    id: "2",
    name: "Delhi",
    state: "Delhi",
    lat: 28.7041,
    lng: 77.1025,
  },
  {
    id: "3",
    name: "Bengaluru",
    state: "Karnataka",
    lat: 12.9716,
    lng: 77.5946,
  },
  {
    id: "4",
    name: "Ahmedabad",
    state: "Gujarat",
    lat: 23.0225,
    lng: 72.5714,
  },
  {
    id: "5",
    name: "Hyderabad",
    state: "Telangana",
    lat: 17.385,
    lng: 78.4867,
  },
  {
    id: "6",
    name: "Chennai",
    state: "Tamil Nadu",
    lat: 13.0827,
    lng: 80.2707,
  },
  {
    id: "7",
    name: "Kolkata",
    state: "West Bengal",
    lat: 22.5726,
    lng: 88.3639,
  },
  {
    id: "8",
    name: "Pune",
    state: "Maharashtra",
    lat: 18.5204,
    lng: 73.8567,
  },
  {
    id: "9",
    name: "Jaipur",
    state: "Rajasthan",
    lat: 26.9124,
    lng: 75.7873,
  },
  {
    id: "10",
    name: "Surat",
    state: "Gujarat",
    lat: 21.1702,
    lng: 72.8311,
  },
  {
    id: "11",
    name: "Lucknow",
    state: "Uttar Pradesh",
    lat: 26.8467,
    lng: 80.9462,
  },
  {
    id: "12",
    name: "Kanpur",
    state: "Uttar Pradesh",
    lat: 26.4499,
    lng: 80.3319,
  },
  {
    id: "13",
    name: "Nagpur",
    state: "Maharashtra",
    lat: 21.1458,
    lng: 79.0882,
  },
  {
    id: "14",
    name: "Patna",
    state: "Bihar",
    lat: 25.5941,
    lng: 85.1376,
  },
  {
    id: "15",
    name: "Indore",
    state: "Madhya Pradesh",
    lat: 22.7196,
    lng: 75.8577,
  },
  {
    id: "16",
    name: "Thane",
    state: "Maharashtra",
    lat: 19.2183,
    lng: 72.9781,
  },
  {
    id: "17",
    name: "Bhopal",
    state: "Madhya Pradesh",
    lat: 23.2599,
    lng: 77.4126,
  },
  {
    id: "18",
    name: "Visakhapatnam",
    state: "Andhra Pradesh",
    lat: 17.6868,
    lng: 83.2185,
  },
  {
    id: "19",
    name: "Vadodara",
    state: "Gujarat",
    lat: 22.3072,
    lng: 73.1812,
  },
  {
    id: "20",
    name: "Firozabad",
    state: "Uttar Pradesh",
    lat: 27.159,
    lng: 78.3958,
  },
  {
    id: "21",
    name: "Ludhiana",
    state: "Punjab",
    lat: 30.901,
    lng: 75.8573,
  },
  {
    id: "22",
    name: "Rajkot",
    state: "Gujarat",
    lat: 22.3039,
    lng: 70.8022,
  },
  {
    id: "23",
    name: "Agra",
    state: "Uttar Pradesh",
    lat: 27.1767,
    lng: 78.0081,
  },
  {
    id: "24",
    name: "Siliguri",
    state: "West Bengal",
    lat: 26.7271,
    lng: 88.3953,
  },
  {
    id: "25",
    name: "Nashik",
    state: "Maharashtra",
    lat: 20.0059,
    lng: 73.7913,
  },
  {
    id: "26",
    name: "Faridabad",
    state: "Haryana",
    lat: 28.4089,
    lng: 77.3178,
  },
  {
    id: "27",
    name: "Patiala",
    state: "Punjab",
    lat: 30.3398,
    lng: 76.3869,
  },
  {
    id: "28",
    name: "Meerut",
    state: "Uttar Pradesh",
    lat: 28.9845,
    lng: 77.7064,
  },
  {
    id: "29",
    name: "Kalyan-Dombivali",
    state: "Maharashtra",
    lat: 19.235,
    lng: 73.1299,
  },
  {
    id: "30",
    name: "Vasai-Virar",
    state: "Maharashtra",
    lat: 19.4259,
    lng: 72.8225,
  },
  {
    id: "31",
    name: "Varanasi",
    state: "Uttar Pradesh",
    lat: 25.3176,
    lng: 82.9739,
  },
  {
    id: "32",
    name: "Srinagar",
    state: "Jammu and Kashmir",
    lat: 34.0837,
    lng: 74.7973,
  },
  {
    id: "33",
    name: "Dhanbad",
    state: "Jharkhand",
    lat: 23.7957,
    lng: 86.4304,
  },
  {
    id: "34",
    name: "Jodhpur",
    state: "Rajasthan",
    lat: 26.2389,
    lng: 73.0243,
  },
  {
    id: "35",
    name: "Amritsar",
    state: "Punjab",
    lat: 31.634,
    lng: 74.8723,
  },
  {
    id: "36",
    name: "Raipur",
    state: "Chhattisgarh",
    lat: 21.2514,
    lng: 81.6296,
  },
  {
    id: "37",
    name: "Allahabad",
    state: "Uttar Pradesh",
    lat: 25.4358,
    lng: 81.8463,
  },
  {
    id: "38",
    name: "Coimbatore",
    state: "Tamil Nadu",
    lat: 11.0168,
    lng: 76.9558,
  },
  {
    id: "39",
    name: "Jabalpur",
    state: "Madhya Pradesh",
    lat: 23.1815,
    lng: 79.9864,
  },
  {
    id: "40",
    name: "Gwalior",
    state: "Madhya Pradesh",
    lat: 26.2183,
    lng: 78.1828,
  },
  {
    id: "41",
    name: "Vijayawada",
    state: "Andhra Pradesh",
    lat: 16.5062,
    lng: 80.648,
  },
  {
    id: "42",
    name: "Madurai",
    state: "Tamil Nadu",
    lat: 9.9252,
    lng: 78.1198,
  },
  {
    id: "43",
    name: "Guwahati",
    state: "Assam",
    lat: 26.1445,
    lng: 91.7362,
  },
  {
    id: "44",
    name: "Chandigarh",
    state: "Chandigarh",
    lat: 30.7333,
    lng: 76.7794,
  },
  {
    id: "45",
    name: "Hubli-Dharwad",
    state: "Karnataka",
    lat: 15.3647,
    lng: 75.124,
  },
  {
    id: "46",
    name: "Amroha",
    state: "Uttar Pradesh",
    lat: 28.903,
    lng: 78.4698,
  },
  {
    id: "47",
    name: "Moradabad",
    state: "Uttar Pradesh",
    lat: 28.8389,
    lng: 78.7768,
  },
  {
    id: "48",
    name: "Gurgaon",
    state: "Haryana",
    lat: 28.4595,
    lng: 77.0266,
  },
  {
    id: "49",
    name: "Aligarh",
    state: "Uttar Pradesh",
    lat: 27.8974,
    lng: 78.088,
  },
  {
    id: "50",
    name: "Solapur",
    state: "Maharashtra",
    lat: 17.6599,
    lng: 75.9064,
  },
  {
    id: "51",
    name: "Ranchi",
    state: "Jharkhand",
    lat: 23.3441,
    lng: 85.3096,
  },
  {
    id: "52",
    name: "Jalandhar",
    state: "Punjab",
    lat: 31.326,
    lng: 75.5762,
  },
  {
    id: "53",
    name: "Tiruchirappalli",
    state: "Tamil Nadu",
    lat: 10.7905,
    lng: 78.7047,
  },
  {
    id: "54",
    name: "Bhubaneswar",
    state: "Odisha",
    lat: 20.2961,
    lng: 85.8245,
  },
  {
    id: "55",
    name: "Salem",
    state: "Tamil Nadu",
    lat: 11.6643,
    lng: 78.146,
  },
  {
    id: "56",
    name: "Warangal",
    state: "Telangana",
    lat: 17.9689,
    lng: 79.5941,
  },
  {
    id: "57",
    name: "Mira-Bhayandar",
    state: "Maharashtra",
    lat: 19.2952,
    lng: 72.8544,
  },
  {
    id: "58",
    name: "Thiruvananthapuram",
    state: "Kerala",
    lat: 8.5241,
    lng: 76.9366,
  },
  {
    id: "59",
    name: "Bhiwandi",
    state: "Maharashtra",
    lat: 19.3002,
    lng: 73.0588,
  },
  {
    id: "60",
    name: "Saharanpur",
    state: "Uttar Pradesh",
    lat: 29.9679,
    lng: 77.5451,
  },
  {
    id: "61",
    name: "Guntur",
    state: "Andhra Pradesh",
    lat: 16.3067,
    lng: 80.4365,
  },
  {
    id: "62",
    name: "Amravati",
    state: "Maharashtra",
    lat: 20.9374,
    lng: 77.7796,
  },
  {
    id: "63",
    name: "Bikaner",
    state: "Rajasthan",
    lat: 28.0229,
    lng: 73.3119,
  },
  {
    id: "64",
    name: "Noida",
    state: "Uttar Pradesh",
    lat: 28.5355,
    lng: 77.391,
  },
  {
    id: "65",
    name: "Jamshedpur",
    state: "Jharkhand",
    lat: 22.8046,
    lng: 86.2029,
  },
  {
    id: "66",
    name: "Bhilai Nagar",
    state: "Chhattisgarh",
    lat: 21.1938,
    lng: 81.3509,
  },
  {
    id: "67",
    name: "Cuttack",
    state: "Odisha",
    lat: 20.4625,
    lng: 85.889,
  },
  {
    id: "68",
    name: "Kochi",
    state: "Kerala",
    lat: 9.9312,
    lng: 76.2673,
  },
  {
    id: "69",
    name: "Udaipur",
    state: "Rajasthan",
    lat: 24.5854,
    lng: 73.7125,
  },
  {
    id: "70",
    name: "Bhavnagar",
    state: "Gujarat",
    lat: 21.7645,
    lng: 72.1519,
  },
  {
    id: "71",
    name: "Dehradun",
    state: "Uttarakhand",
    lat: 30.3165,
    lng: 78.0322,
  },
  {
    id: "72",
    name: "Asansol",
    state: "West Bengal",
    lat: 23.6739,
    lng: 86.9524,
  },
  {
    id: "73",
    name: "Nanded-Waghala",
    state: "Maharashtra",
    lat: 19.1383,
    lng: 77.321,
  },
  {
    id: "74",
    name: "Ajmer",
    state: "Rajasthan",
    lat: 26.4499,
    lng: 74.6399,
  },
  {
    id: "75",
    name: "Jamnagar",
    state: "Gujarat",
    lat: 22.4707,
    lng: 70.0577,
  },
  {
    id: "76",
    name: "Ujjain",
    state: "Madhya Pradesh",
    lat: 23.1793,
    lng: 75.7849,
  },
  {
    id: "77",
    name: "Sangli",
    state: "Maharashtra",
    lat: 16.8524,
    lng: 74.5815,
  },
  {
    id: "78",
    name: "Loni",
    state: "Uttar Pradesh",
    lat: 28.7515,
    lng: 77.2885,
  },
  {
    id: "79",
    name: "Jhansi",
    state: "Uttar Pradesh",
    lat: 25.4484,
    lng: 78.5685,
  },
  {
    id: "80",
    name: "Pondicherry",
    state: "Puducherry",
    lat: 11.9416,
    lng: 79.8083,
  },
  {
    id: "81",
    name: "Nellore",
    state: "Andhra Pradesh",
    lat: 14.4426,
    lng: 79.9865,
  },
  {
    id: "82",
    name: "Jammu",
    state: "Jammu and Kashmir",
    lat: 32.7266,
    lng: 74.857,
  },
  {
    id: "83",
    name: "Belagavi",
    state: "Karnataka",
    lat: 15.8497,
    lng: 74.4977,
  },
  {
    id: "84",
    name: "Raurkela",
    state: "Odisha",
    lat: 22.2492,
    lng: 84.8828,
  },
  {
    id: "85",
    name: "Mangaluru",
    state: "Karnataka",
    lat: 12.9141,
    lng: 74.856,
  },
  {
    id: "86",
    name: "Tirunelveli",
    state: "Tamil Nadu",
    lat: 8.7139,
    lng: 77.7567,
  },
  {
    id: "87",
    name: "Malegaon",
    state: "Maharashtra",
    lat: 20.5538,
    lng: 74.5255,
  },
  {
    id: "88",
    name: "Gaya",
    state: "Bihar",
    lat: 24.7955,
    lng: 85.0125,
  },
  {
    id: "89",
    name: "Tiruppur",
    state: "Tamil Nadu",
    lat: 11.1085,
    lng: 77.3411,
  },
  {
    id: "90",
    name: "Davanagere",
    state: "Karnataka",
    lat: 14.4644,
    lng: 75.9218,
  },
  {
    id: "91",
    name: "Kozhikode",
    state: "Kerala",
    lat: 11.2588,
    lng: 75.7804,
  },
  {
    id: "92",
    name: "Akola",
    state: "Maharashtra",
    lat: 20.7096,
    lng: 77.0022,
  },
  {
    id: "93",
    name: "Kurnool",
    state: "Andhra Pradesh",
    lat: 15.8281,
    lng: 78.0373,
  },
  {
    id: "94",
    name: "Bokaro Steel City",
    state: "Jharkhand",
    lat: 23.6693,
    lng: 86.1511,
  },
  {
    id: "95",
    name: "Rajahmundry",
    state: "Andhra Pradesh",
    lat: 16.9944,
    lng: 81.7796,
  },
  {
    id: "96",
    name: "Ballari",
    state: "Karnataka",
    lat: 15.1394,
    lng: 76.9214,
  },
  {
    id: "97",
    name: "Agartala",
    state: "Tripura",
    lat: 23.8315,
    lng: 91.2868,
  },
  {
    id: "98",
    name: "Bhagalpur",
    state: "Bihar",
    lat: 25.2445,
    lng: 86.9718,
  },
  {
    id: "99",
    name: "Latur",
    state: "Maharashtra",
    lat: 18.4088,
    lng: 76.5604,
  },
  {
    id: "100",
    name: "Dhule",
    state: "Maharashtra",
    lat: 20.9042,
    lng: 74.7749,
  },
  {
    id: "101",
    name: "Korba",
    state: "Chhattisgarh",
    lat: 22.3454,
    lng: 82.6963,
  },
  {
    id: "102",
    name: "Bhilwara",
    state: "Rajasthan",
    lat: 25.3463,
    lng: 74.6364,
  },
  {
    id: "103",
    name: "Brahmapur",
    state: "Odisha",
    lat: 19.3142,
    lng: 84.7941,
  },
  {
    id: "104",
    name: "Mysore",
    state: "Karnataka",
    lat: 12.2958,
    lng: 76.6394,
  },
  {
    id: "105",
    name: "Muzaffarpur",
    state: "Bihar",
    lat: 26.1209,
    lng: 85.3647,
  },
  {
    id: "106",
    name: "Ahmednagar",
    state: "Maharashtra",
    lat: 19.0952,
    lng: 74.7496,
  },
  {
    id: "107",
    name: "Kollam",
    state: "Kerala",
    lat: 8.8932,
    lng: 76.6141,
  },
  {
    id: "108",
    name: "Raghunathganj",
    state: "West Bengal",
    lat: 24.4539,
    lng: 88.0818,
  },
  {
    id: "109",
    name: "Bilaspur",
    state: "Chhattisgarh",
    lat: 22.0735,
    lng: 82.1514,
  },
  {
    id: "110",
    name: "Shahjahanpur",
    state: "Uttar Pradesh",
    lat: 27.8804,
    lng: 79.905,
  },
  {
    id: "111",
    name: "Thrissur",
    state: "Kerala",
    lat: 10.5276,
    lng: 76.2144,
  },
  {
    id: "112",
    name: "Alwar",
    state: "Rajasthan",
    lat: 27.5535,
    lng: 76.6346,
  },
  {
    id: "113",
    name: "Kakinada",
    state: "Andhra Pradesh",
    lat: 16.9891,
    lng: 82.2475,
  },
  {
    id: "114",
    name: "Nizamabad",
    state: "Telangana",
    lat: 18.6725,
    lng: 78.0941,
  },
  {
    id: "115",
    name: "Sagar",
    state: "Madhya Pradesh",
    lat: 23.8388,
    lng: 78.7378,
  },
  {
    id: "116",
    name: "Tumkur",
    state: "Karnataka",
    lat: 13.3409,
    lng: 77.101,
  },
  {
    id: "117",
    name: "Hisar",
    state: "Haryana",
    lat: 29.1492,
    lng: 75.7217,
  },
  {
    id: "118",
    name: "Rohtak",
    state: "Haryana",
    lat: 28.8955,
    lng: 76.6066,
  },
  {
    id: "119",
    name: "Panipat",
    state: "Haryana",
    lat: 29.3909,
    lng: 76.9635,
  },
  {
    id: "120",
    name: "Darbhanga",
    state: "Bihar",
    lat: 26.1527,
    lng: 85.897,
  },
  {
    id: "121",
    name: "Kharagpur",
    state: "West Bengal",
    lat: 22.346,
    lng: 87.232,
  },
  {
    id: "122",
    name: "Aizawl",
    state: "Mizoram",
    lat: 23.7271,
    lng: 92.7176,
  },
  {
    id: "123",
    name: "Ichalkaranji",
    state: "Maharashtra",
    lat: 16.7088,
    lng: 74.4669,
  },
  {
    id: "124",
    name: "Tirupati",
    state: "Andhra Pradesh",
    lat: 13.6288,
    lng: 79.4192,
  },
  {
    id: "125",
    name: "Karnal",
    state: "Haryana",
    lat: 29.6857,
    lng: 76.9905,
  },
  {
    id: "126",
    name: "Bathinda",
    state: "Punjab",
    lat: 30.207,
    lng: 74.9455,
  },
  {
    id: "127",
    name: "Rampur",
    state: "Uttar Pradesh",
    lat: 28.8034,
    lng: 79.0254,
  },
  {
    id: "128",
    name: "Shivamogga",
    state: "Karnataka",
    lat: 13.9299,
    lng: 75.5681,
  },
  {
    id: "129",
    name: "Ratlam",
    state: "Madhya Pradesh",
    lat: 23.3346,
    lng: 75.0376,
  },
  {
    id: "130",
    name: "Modinagar",
    state: "Uttar Pradesh",
    lat: 28.8391,
    lng: 77.5398,
  },
  {
    id: "131",
    name: "Durg",
    state: "Chhattisgarh",
    lat: 21.1904,
    lng: 81.2849,
  },
  {
    id: "132",
    name: "Shillong",
    state: "Meghalaya",
    lat: 25.5788,
    lng: 91.8933,
  },
  {
    id: "133",
    name: "Imphal",
    state: "Manipur",
    lat: 24.817,
    lng: 93.9368,
  },
  {
    id: "134",
    name: "Hapur",
    state: "Uttar Pradesh",
    lat: 28.7433,
    lng: 77.7628,
  },
  {
    id: "135",
    name: "Ranipet",
    state: "Tamil Nadu",
    lat: 12.9344,
    lng: 79.3314,
  },
  {
    id: "136",
    name: "Anantapur",
    state: "Andhra Pradesh",
    lat: 14.6819,
    lng: 77.6006,
  },
  {
    id: "137",
    name: "Arrah",
    state: "Bihar",
    lat: 25.5543,
    lng: 84.6624,
  },
  {
    id: "138",
    name: "Karimnagar",
    state: "Telangana",
    lat: 18.4386,
    lng: 79.1288,
  },
  {
    id: "139",
    name: "Parbhani",
    state: "Maharashtra",
    lat: 19.2686,
    lng: 76.7708,
  },
  {
    id: "140",
    name: "Etawah",
    state: "Uttar Pradesh",
    lat: 26.7766,
    lng: 79.0219,
  },
  {
    id: "141",
    name: "Bharatpur",
    state: "Rajasthan",
    lat: 27.2153,
    lng: 77.4927,
  },
  {
    id: "142",
    name: "Begusarai",
    state: "Bihar",
    lat: 25.418,
    lng: 86.13,
  },
  {
    id: "143",
    name: "New Delhi",
    state: "Delhi",
    lat: 28.6139,
    lng: 77.209,
  },
  {
    id: "144",
    name: "Chhapra",
    state: "Bihar",
    lat: 25.7849,
    lng: 84.7274,
  },
  {
    id: "145",
    name: "Kadapa",
    state: "Andhra Pradesh",
    lat: 14.4742,
    lng: 78.7098,
  },
  {
    id: "146",
    name: "Ramagundam",
    state: "Telangana",
    lat: 18.755,
    lng: 79.474,
  },
  {
    id: "147",
    name: "Pali",
    state: "Rajasthan",
    lat: 25.7721,
    lng: 73.3233,
  },
  {
    id: "148",
    name: "Satna",
    state: "Madhya Pradesh",
    lat: 24.576,
    lng: 80.8322,
  },
  {
    id: "149",
    name: "Vizianagaram",
    state: "Andhra Pradesh",
    lat: 18.1066,
    lng: 83.3956,
  },
  {
    id: "150",
    name: "Katihar",
    state: "Bihar",
    lat: 25.5405,
    lng: 87.5854,
  },
  {
    id: "151",
    name: "Hardwar",
    state: "Uttarakhand",
    lat: 29.9457,
    lng: 78.1642,
  },
  {
    id: "152",
    name: "Sonipat",
    state: "Haryana",
    lat: 28.9931,
    lng: 77.0151,
  },
  {
    id: "153",
    name: "Nagercoil",
    state: "Tamil Nadu",
    lat: 8.1773,
    lng: 77.4344,
  },
  {
    id: "154",
    name: "Thanjavur",
    state: "Tamil Nadu",
    lat: 10.7867,
    lng: 79.1378,
  },
  {
    id: "155",
    name: "Murwara (Katni)",
    state: "Madhya Pradesh",
    lat: 23.8376,
    lng: 80.3946,
  },
  {
    id: "156",
    name: "Naihati",
    state: "West Bengal",
    lat: 22.8949,
    lng: 88.4189,
  },
  {
    id: "157",
    name: "Sambhal",
    state: "Uttar Pradesh",
    lat: 28.5841,
    lng: 78.5696,
  },
  {
    id: "158",
    name: "Nadiad",
    state: "Gujarat",
    lat: 22.6939,
    lng: 72.8616,
  },
  {
    id: "159",
    name: "Yamunanagar",
    state: "Haryana",
    lat: 30.129,
    lng: 77.2674,
  },
  {
    id: "160",
    name: "English Bazar",
    state: "West Bengal",
    lat: 25.0105,
    lng: 88.1408,
  },
  {
    id: "161",
    name: "Eluru",
    state: "Andhra Pradesh",
    lat: 16.7065,
    lng: 81.1006,
  },
  {
    id: "162",
    name: "Munger",
    state: "Bihar",
    lat: 25.3748,
    lng: 86.4737,
  },
  {
    id: "163",
    name: "Panchkula",
    state: "Haryana",
    lat: 30.6942,
    lng: 76.8606,
  },
  {
    id: "164",
    name: "Raayachuru",
    state: "Karnataka",
    lat: 16.2049,
    lng: 77.3557,
  },
  {
    id: "165",
    name: "Panvel",
    state: "Maharashtra",
    lat: 18.9888,
    lng: 73.1101,
  },
  {
    id: "166",
    name: "Deoghar",
    state: "Jharkhand",
    lat: 24.4863,
    lng: 86.7009,
  },
  {
    id: "167",
    name: "Ongole",
    state: "Andhra Pradesh",
    lat: 15.5057,
    lng: 80.0499,
  },
  {
    id: "168",
    name: "Nandyal",
    state: "Andhra Pradesh",
    lat: 15.4776,
    lng: 78.483,
  },
  {
    id: "169",
    name: "Morena",
    state: "Madhya Pradesh",
    lat: 26.4983,
    lng: 77.9952,
  },
  {
    id: "170",
    name: "Bhiwani",
    state: "Haryana",
    lat: 28.793,
    lng: 76.1397,
  },
  {
    id: "171",
    name: "Porbandar",
    state: "Gujarat",
    lat: 21.6417,
    lng: 69.6293,
  },
  {
    id: "172",
    name: "Palakkad",
    state: "Kerala",
    lat: 10.7867,
    lng: 76.6548,
  },
  {
    id: "173",
    name: "Anand",
    state: "Gujarat",
    lat: 22.5645,
    lng: 72.9289,
  },
  {
    id: "174",
    name: "Purnia",
    state: "Bihar",
    lat: 25.7776,
    lng: 87.4752,
  },
  {
    id: "175",
    name: "Baharampur",
    state: "West Bengal",
    lat: 24.1047,
    lng: 88.2515,
  },
  {
    id: "176",
    name: "Barmer",
    state: "Rajasthan",
    lat: 25.7463,
    lng: 71.3924,
  },
  {
    id: "177",
    name: "Morvi",
    state: "Gujarat",
    lat: 22.8173,
    lng: 70.8372,
  },
  {
    id: "178",
    name: "Orai",
    state: "Uttar Pradesh",
    lat: 25.9891,
    lng: 79.4533,
  },
  {
    id: "179",
    name: "Bahraich",
    state: "Uttar Pradesh",
    lat: 27.5753,
    lng: 81.5948,
  },
  {
    id: "180",
    name: "Sikar",
    state: "Rajasthan",
    lat: 27.6093,
    lng: 75.1397,
  },
  {
    id: "181",
    name: "Vellore",
    state: "Tamil Nadu",
    lat: 12.9165,
    lng: 79.1325,
  },
  {
    id: "182",
    name: "Singrauli",
    state: "Madhya Pradesh",
    lat: 24.1994,
    lng: 82.6754,
  },
  {
    id: "183",
    name: "Khammam",
    state: "Telangana",
    lat: 17.2473,
    lng: 80.1514,
  },
  {
    id: "184",
    name: "Mahesana",
    state: "Gujarat",
    lat: 23.587,
    lng: 72.3693,
  },
  {
    id: "185",
    name: "Silchar",
    state: "Assam",
    lat: 24.8333,
    lng: 92.7789,
  },
  {
    id: "186",
    name: "Sambalpur",
    state: "Odisha",
    lat: 21.4704,
    lng: 83.9701,
  },
  {
    id: "187",
    name: "Rewa",
    state: "Madhya Pradesh",
    lat: 24.5373,
    lng: 81.3042,
  },
  {
    id: "188",
    name: "Unnao",
    state: "Uttar Pradesh",
    lat: 26.5393,
    lng: 80.4879,
  },
  {
    id: "189",
    name: "Hugli-Chinsurah",
    state: "West Bengal",
    lat: 22.9,
    lng: 88.39,
  },
  {
    id: "190",
    name: "Raiganj",
    state: "West Bengal",
    lat: 25.6135,
    lng: 88.1164,
  },
  {
    id: "191",
    name: "Phusro",
    state: "Jharkhand",
    lat: 23.7733,
    lng: 85.9976,
  },
  {
    id: "192",
    name: "Adityapur",
    state: "Jharkhand",
    lat: 22.7904,
    lng: 86.165,
  },
  {
    id: "193",
    name: "Alappuzha",
    state: "Kerala",
    lat: 9.4981,
    lng: 76.3388,
  },
  {
    id: "194",
    name: "Bahadurgarh",
    state: "Haryana",
    lat: 28.6928,
    lng: 76.9356,
  },
  {
    id: "195",
    name: "Machilipatnam",
    state: "Andhra Pradesh",
    lat: 16.1875,
    lng: 81.1389,
  },
  {
    id: "196",
    name: "Rae Bareli",
    state: "Uttar Pradesh",
    lat: 26.2309,
    lng: 81.2332,
  },
  {
    id: "197",
    name: "Jalpaiguri",
    state: "West Bengal",
    lat: 26.5167,
    lng: 88.7333,
  },
  {
    id: "198",
    name: "Bharuch",
    state: "Gujarat",
    lat: 21.7051,
    lng: 72.9959,
  },
  {
    id: "199",
    name: "Pathankot",
    state: "Punjab",
    lat: 32.2746,
    lng: 75.6527,
  },
  {
    id: "200",
    name: "Hoshiarpur",
    state: "Punjab",
    lat: 31.5322,
    lng: 75.9172,
  },
  {
    id: "201",
    name: "Baramula",
    state: "Jammu and Kashmir",
    lat: 34.1985,
    lng: 74.3639,
  },
  {
    id: "202",
    name: "Adoni",
    state: "Andhra Pradesh",
    lat: 15.6279,
    lng: 77.2749,
  },
  {
    id: "203",
    name: "Jind",
    state: "Haryana",
    lat: 29.3167,
    lng: 76.3167,
  },
  {
    id: "204",
    name: "Tonk",
    state: "Rajasthan",
    lat: 26.1667,
    lng: 75.7833,
  },
  {
    id: "205",
    name: "Tenali",
    state: "Andhra Pradesh",
    lat: 16.243,
    lng: 80.64,
  },
  {
    id: "206",
    name: "Kancheepuram",
    state: "Tamil Nadu",
    lat: 12.8333,
    lng: 79.7167,
  },
  {
    id: "207",
    name: "Vapi",
    state: "Gujarat",
    lat: 20.3718,
    lng: 72.9049,
  },
  {
    id: "208",
    name: "Sirsa",
    state: "Haryana",
    lat: 29.5333,
    lng: 75.0167,
  },
  {
    id: "209",
    name: "Navsari",
    state: "Gujarat",
    lat: 20.95,
    lng: 72.9333,
  },
  {
    id: "210",
    name: "Mahbubnagar",
    state: "Telangana",
    lat: 16.7333,
    lng: 77.9833,
  },
  {
    id: "211",
    name: "Puri",
    state: "Odisha",
    lat: 19.8,
    lng: 85.8167,
  },
  {
    id: "212",
    name: "Robertson Pet",
    state: "Karnataka",
    lat: 12.9667,
    lng: 78.2833,
  },
  {
    id: "213",
    name: "Erode",
    state: "Tamil Nadu",
    lat: 11.341,
    lng: 77.7172,
  },
  {
    id: "214",
    name: "Batala",
    state: "Punjab",
    lat: 31.8186,
    lng: 75.2028,
  },
  {
    id: "215",
    name: "Haldwani-cum-Kathgodam",
    state: "Uttarakhand",
    lat: 29.2167,
    lng: 79.5167,
  },
  {
    id: "216",
    name: "Vidisha",
    state: "Madhya Pradesh",
    lat: 23.5333,
    lng: 77.8167,
  },
  {
    id: "217",
    name: "Saharsa",
    state: "Bihar",
    lat: 25.8833,
    lng: 86.6,
  },
  {
    id: "218",
    name: "Thanesar",
    state: "Haryana",
    lat: 29.9667,
    lng: 76.8167,
  },
  {
    id: "219",
    name: "Chittoor",
    state: "Andhra Pradesh",
    lat: 13.2,
    lng: 79.1167,
  },
  {
    id: "220",
    name: "Veraval",
    state: "Gujarat",
    lat: 20.9,
    lng: 70.3667,
  },
  {
    id: "221",
    name: "Lakhimpur",
    state: "Uttar Pradesh",
    lat: 27.95,
    lng: 80.7833,
  },
  {
    id: "222",
    name: "Sitapur",
    state: "Uttar Pradesh",
    lat: 27.5667,
    lng: 80.6833,
  },
  {
    id: "223",
    name: "Hindupur",
    state: "Andhra Pradesh",
    lat: 13.83,
    lng: 77.49,
  },
  {
    id: "224",
    name: "Santipur",
    state: "West Bengal",
    lat: 23.25,
    lng: 88.43,
  },
  {
    id: "225",
    name: "Balurghat",
    state: "West Bengal",
    lat: 25.2167,
    lng: 88.7667,
  },
  {
    id: "226",
    name: "Ganjbasoda",
    state: "Madhya Pradesh",
    lat: 23.8,
    lng: 77.9333,
  },
  {
    id: "227",
    name: "Moga",
    state: "Punjab",
    lat: 30.8167,
    lng: 75.1667,
  },
  {
    id: "228",
    name: "Proddatur",
    state: "Andhra Pradesh",
    lat: 14.73,
    lng: 78.55,
  },
  {
    id: "229",
    name: "Srinagar",
    state: "Uttarakhand",
    lat: 30.22,
    lng: 78.78,
  },
  {
    id: "230",
    name: "Medinipur",
    state: "West Bengal",
    lat: 22.4333,
    lng: 87.3333,
  },
  {
    id: "231",
    name: "Habra",
    state: "West Bengal",
    lat: 22.83,
    lng: 88.63,
  },
  {
    id: "232",
    name: "Sasaram",
    state: "Bihar",
    lat: 24.95,
    lng: 84.03,
  },
  {
    id: "233",
    name: "Hajipur",
    state: "Bihar",
    lat: 25.6833,
    lng: 85.1833,
  },
  {
    id: "234",
    name: "Bhuj",
    state: "Gujarat",
    lat: 23.25,
    lng: 69.81,
  },
  {
    id: "235",
    name: "Shivpuri",
    state: "Madhya Pradesh",
    lat: 25.43,
    lng: 77.65,
  },
  {
    id: "236",
    name: "Ranaghat",
    state: "West Bengal",
    lat: 23.18,
    lng: 88.58,
  },
  {
    id: "237",
    name: "Shimla",
    state: "Himachal Pradesh",
    lat: 31.1033,
    lng: 77.1722,
  },
  {
    id: "238",
    name: "Tiruvannamalai",
    state: "Tamil Nadu",
    lat: 12.26,
    lng: 79.1,
  },
  {
    id: "239",
    name: "Kaithal",
    state: "Haryana",
    lat: 29.8,
    lng: 76.3833,
  },
  {
    id: "240",
    name: "Rajnandgaon",
    state: "Chhattisgarh",
    lat: 21.1,
    lng: 81.03,
  },
  {
    id: "241",
    name: "Godhra",
    state: "Gujarat",
    lat: 22.7772,
    lng: 73.6203,
  },
  {
    id: "242",
    name: "Hazaribag",
    state: "Jharkhand",
    lat: 23.9833,
    lng: 85.35,
  },
  {
    id: "243",
    name: "Bhimavaram",
    state: "Andhra Pradesh",
    lat: 16.5333,
    lng: 81.5333,
  },
  {
    id: "244",
    name: "Mandsaur",
    state: "Madhya Pradesh",
    lat: 24.03,
    lng: 75.08,
  },
  {
    id: "245",
    name: "Dibrugarh",
    state: "Assam",
    lat: 27.4833,
    lng: 94.9,
  },
  {
    id: "246",
    name: "Kolar",
    state: "Karnataka",
    lat: 13.1333,
    lng: 78.1333,
  },
  {
    id: "247",
    name: "Bankura",
    state: "West Bengal",
    lat: 23.25,
    lng: 87.0667,
  },
  {
    id: "248",
    name: "Mandya",
    state: "Karnataka",
    lat: 12.52,
    lng: 76.9,
  },
  {
    id: "249",
    name: "Dehri-on-Sone",
    state: "Bihar",
    lat: 24.9167,
    lng: 84.1833,
  },
  {
    id: "250",
    name: "Madanapalle",
    state: "Andhra Pradesh",
    lat: 13.55,
    lng: 78.5,
  },
  {
    id: "251",
    name: "Malerkotla",
    state: "Punjab",
    lat: 30.53,
    lng: 75.88,
  },
  {
    id: "252",
    name: "Lalitpur",
    state: "Uttar Pradesh",
    lat: 24.69,
    lng: 78.41,
  },
  {
    id: "253",
    name: "Bettiah",
    state: "Bihar",
    lat: 26.8,
    lng: 84.5,
  },
  {
    id: "254",
    name: "Pollachi",
    state: "Tamil Nadu",
    lat: 10.66,
    lng: 77.01,
  },
  {
    id: "255",
    name: "Khanna",
    state: "Punjab",
    lat: 30.7,
    lng: 76.22,
  },
  {
    id: "256",
    name: "Neemuch",
    state: "Madhya Pradesh",
    lat: 24.47,
    lng: 74.87,
  },
  {
    id: "257",
    name: "Palwal",
    state: "Haryana",
    lat: 28.15,
    lng: 77.33,
  },
  {
    id: "258",
    name: "Palanpur",
    state: "Gujarat",
    lat: 24.17,
    lng: 72.43,
  },
  {
    id: "259",
    name: "Guntakal",
    state: "Andhra Pradesh",
    lat: 15.17,
    lng: 77.38,
  },
  {
    id: "260",
    name: "Nabadwip",
    state: "West Bengal",
    lat: 23.4,
    lng: 88.37,
  },
  {
    id: "261",
    name: "Udupi",
    state: "Karnataka",
    lat: 13.3322,
    lng: 74.7461,
  },
  {
    id: "262",
    name: "Jagdalpur",
    state: "Chhattisgarh",
    lat: 19.07,
    lng: 82.03,
  },
  {
    id: "263",
    name: "Motihari",
    state: "Bihar",
    lat: 26.65,
    lng: 84.9167,
  },
  {
    id: "264",
    name: "Pilibhit",
    state: "Uttar Pradesh",
    lat: 28.63,
    lng: 79.8,
  },
  {
    id: "265",
    name: "Dimapur",
    state: "Nagaland",
    lat: 25.9,
    lng: 93.73,
  },
  {
    id: "266",
    name: "Mohali",
    state: "Punjab",
    lat: 30.7046,
    lng: 76.7179,
  },
  {
    id: "267",
    name: "Sadulpur",
    state: "Rajasthan",
    lat: 28.17,
    lng: 75.57,
  },
  {
    id: "268",
    name: "Rajapalayam",
    state: "Tamil Nadu",
    lat: 9.45,
    lng: 77.55,
  },
  {
    id: "269",
    name: "Dharmavaram",
    state: "Andhra Pradesh",
    lat: 14.43,
    lng: 77.72,
  },
  {
    id: "270",
    name: "Kashipur",
    state: "Uttarakhand",
    lat: 29.21,
    lng: 78.95,
  },
  {
    id: "271",
    name: "Sivakasi",
    state: "Tamil Nadu",
    lat: 9.45,
    lng: 77.82,
  },
  {
    id: "272",
    name: "Darjiling",
    state: "West Bengal",
    lat: 27.0417,
    lng: 88.2631,
  },
  {
    id: "273",
    name: "Chikkamagaluru",
    state: "Karnataka",
    lat: 13.3167,
    lng: 75.7833,
  },
  {
    id: "274",
    name: "Gudivada",
    state: "Andhra Pradesh",
    lat: 16.43,
    lng: 80.99,
  },
  {
    id: "275",
    name: "Baleshwar Town",
    state: "Odisha",
    lat: 21.4942,
    lng: 86.9317,
  },
  {
    id: "276",
    name: "Mancherial",
    state: "Telangana",
    lat: 18.87,
    lng: 79.43,
  },
  {
    id: "277",
    name: "Srikakulam",
    state: "Andhra Pradesh",
    lat: 18.3,
    lng: 83.9,
  },
  {
    id: "278",
    name: "Adilabad",
    state: "Telangana",
    lat: 19.6667,
    lng: 78.5333,
  },
  {
    id: "279",
    name: "Yavatmal",
    state: "Maharashtra",
    lat: 20.4,
    lng: 78.1333,
  },
  {
    id: "280",
    name: "Barnala",
    state: "Punjab",
    lat: 30.38,
    lng: 75.55,
  },
  {
    id: "281",
    name: "Nagaon",
    state: "Assam",
    lat: 26.35,
    lng: 92.6833,
  },
  {
    id: "282",
    name: "Narasaraopet",
    state: "Andhra Pradesh",
    lat: 16.236,
    lng: 80.054,
  },
  {
    id: "283",
    name: "Raigarh",
    state: "Chhattisgarh",
    lat: 21.9,
    lng: 83.4,
  },
  {
    id: "284",
    name: "Roorkee",
    state: "Uttarakhand",
    lat: 29.85,
    lng: 77.8833,
  },
  {
    id: "285",
    name: "Valsad",
    state: "Gujarat",
    lat: 20.63,
    lng: 72.93,
  },
  {
    id: "286",
    name: "Ambikapur",
    state: "Chhattisgarh",
    lat: 23.12,
    lng: 83.2,
  },
  {
    id: "287",
    name: "Giridih",
    state: "Jharkhand",
    lat: 24.18,
    lng: 86.3,
  },
  {
    id: "288",
    name: "Chandausi",
    state: "Uttar Pradesh",
    lat: 28.45,
    lng: 78.77,
  },
  {
    id: "289",
    name: "Purulia",
    state: "West Bengal",
    lat: 23.33,
    lng: 86.37,
  },
  {
    id: "290",
    name: "Patan",
    state: "Gujarat",
    lat: 23.85,
    lng: 72.13,
  },
  {
    id: "291",
    name: "Bagaha",
    state: "Bihar",
    lat: 27.1,
    lng: 84.08,
  },
  {
    id: "292",
    name: "Hardoi ",
    state: "Uttar Pradesh",
    lat: 27.4167,
    lng: 80.1167,
  },
  {
    id: "293",
    name: "Achalpur",
    state: "Maharashtra",
    lat: 21.2572,
    lng: 77.5086,
  },
  {
    id: "294",
    name: "Osmanabad",
    state: "Maharashtra",
    lat: 18.1667,
    lng: 76.05,
  },
  {
    id: "295",
    name: "Deesa",
    state: "Gujarat",
    lat: 24.25,
    lng: 72.18,
  },
  {
    id: "296",
    name: "Nandurbar",
    state: "Maharashtra",
    lat: 21.37,
    lng: 74.25,
  },
  {
    id: "297",
    name: "Azamgarh",
    state: "Uttar Pradesh",
    lat: 26.0675,
    lng: 83.1836,
  },
  {
    id: "298",
    name: "Ramgarh",
    state: "Jharkhand",
    lat: 23.63,
    lng: 85.52,
  },
  {
    id: "299",
    name: "Firozpur",
    state: "Punjab",
    lat: 30.9167,
    lng: 74.6,
  },
  {
    id: "300",
    name: "Baripada Town",
    state: "Odisha",
    lat: 21.93,
    lng: 86.73,
  },

  {
    id: "301",
    name: "Karwar",
    state: "Karnataka",
    lat: 14.8136,
    lng: 74.1297,
  },
  {
    id: "302",
    name: "Siwan",
    state: "Bihar",
    lat: 26.2206,
    lng: 84.3566,
  },
  {
    id: "303",
    name: "Rajampet",
    state: "Andhra Pradesh",
    lat: 14.1953,
    lng: 79.1639,
  },
  {
    id: "304",
    name: "Pudukkottai",
    state: "Tamil Nadu",
    lat: 10.3833,
    lng: 78.8167,
  },
  {
    id: "305",
    name: "Anantnag",
    state: "Jammu and Kashmir",
    lat: 33.7311,
    lng: 75.1547,
  },
  {
    id: "306",
    name: "Tadpatri",
    state: "Andhra Pradesh",
    lat: 14.9094,
    lng: 78.0083,
  },
  {
    id: "307",
    name: "Satara",
    state: "Maharashtra",
    lat: 17.6805,
    lng: 73.9933,
  },
  {
    id: "308",
    name: "Bhadrak",
    state: "Odisha",
    lat: 21.0545,
    lng: 86.5156,
  },
  {
    id: "309",
    name: "Kishanganj",
    state: "Bihar",
    lat: 26.0736,
    lng: 87.9374,
  },
  {
    id: "310",
    name: "Suryapet",
    state: "Telangana",
    lat: 17.1406,
    lng: 79.6201,
  },
  {
    id: "311",
    name: "Wardha",
    state: "Maharashtra",
    lat: 20.7453,
    lng: 78.6022,
  },
  {
    id: "312",
    name: "Ranebennuru",
    state: "Karnataka",
    lat: 14.6222,
    lng: 75.6295,
  },
  {
    id: "313",
    name: "Amreli",
    state: "Gujarat",
    lat: 21.6225,
    lng: 71.2255,
  },
  {
    id: "314",
    name: "Neyveli (TS)",
    state: "Tamil Nadu",
    lat: 11.6123,
    lng: 79.4871,
  },
  {
    id: "315",
    name: "Jamalpur",
    state: "Bihar",
    lat: 25.3126,
    lng: 86.4889,
  },
  {
    id: "316",
    name: "Marmagao",
    state: "Goa",
    lat: 15.4025,
    lng: 73.8078,
  },
  {
    id: "317",
    name: "Udgir",
    state: "Maharashtra",
    lat: 18.3924,
    lng: 77.1179,
  },
  {
    id: "318",
    name: "Tadepalligudem",
    state: "Andhra Pradesh",
    lat: 16.8134,
    lng: 81.5287,
  },
  {
    id: "319",
    name: "Nagapattinam",
    state: "Tamil Nadu",
    lat: 10.7667,
    lng: 79.8333,
  },
  {
    id: "320",
    name: "Buxar",
    state: "Bihar",
    lat: 25.5645,
    lng: 83.9809,
  },
  {
    id: "321",
    name: "Aurangabad",
    state: "Maharashtra",
    lat: 19.8762,
    lng: 75.3433,
  },
  {
    id: "322",
    name: "Jehanabad",
    state: "Bihar",
    lat: 25.2137,
    lng: 84.9871,
  },
  {
    id: "323",
    name: "Phagwara",
    state: "Punjab",
    lat: 31.224,
    lng: 75.7708,
  },
  {
    id: "324",
    name: "Khair",
    state: "Uttar Pradesh",
    lat: 27.9419,
    lng: 77.8424,
  },
  {
    id: "325",
    name: "Sawai Madhopur",
    state: "Rajasthan",
    lat: 26.0239,
    lng: 76.3445,
  },
  {
    id: "326",
    name: "Kapurthala",
    state: "Punjab",
    lat: 31.3805,
    lng: 75.3815,
  },
  {
    id: "327",
    name: "Chilakaluripet",
    state: "Andhra Pradesh",
    lat: 16.0894,
    lng: 80.1656,
  },
  {
    id: "328",
    name: "Aurangabad",
    state: "Bihar",
    lat: 24.7474,
    lng: 84.3738,
  },
  {
    id: "329",
    name: "Malappuram",
    state: "Kerala",
    lat: 11.05,
    lng: 76.0667,
  },
  {
    id: "330",
    name: "Rewari",
    state: "Haryana",
    lat: 28.182,
    lng: 76.6167,
  },
  {
    id: "331",
    name: "Nagaur",
    state: "Rajasthan",
    lat: 27.2,
    lng: 73.7333,
  },
  {
    id: "332",
    name: "Sultanpur",
    state: "Uttar Pradesh",
    lat: 26.25,
    lng: 82.0,
  },
  {
    id: "333",
    name: "Nagda",
    state: "Madhya Pradesh",
    lat: 23.45,
    lng: 75.4167,
  },
  {
    id: "334",
    name: "Port Blair",
    state: "Andaman and Nicobar Islands",
    lat: 11.6667,
    lng: 92.75,
  },
  {
    id: "335",
    name: "Lakhisarai",
    state: "Bihar",
    lat: 25.1667,
    lng: 86.0833,
  },
  {
    id: "336",
    name: "Panaji",
    state: "Goa",
    lat: 15.4909,
    lng: 73.8278,
  },
  {
    id: "337",
    name: "Tinsukia",
    state: "Assam",
    lat: 27.4833,
    lng: 95.35,
  },
  {
    id: "338",
    name: "Itarsi",
    state: "Madhya Pradesh",
    lat: 22.6148,
    lng: 77.7622,
  },
  {
    id: "339",
    name: "Kohima",
    state: "Nagaland",
    lat: 25.6667,
    lng: 94.1167,
  },
  {
    id: "340",
    name: "Balangir",
    state: "Odisha",
    lat: 20.72,
    lng: 83.48,
  },
  {
    id: "341",
    name: "Nawada",
    state: "Bihar",
    lat: 24.88,
    lng: 85.53,
  },
  {
    id: "342",
    name: "Jharsuguda",
    state: "Odisha",
    lat: 21.85,
    lng: 84.03,
  },
  {
    id: "343",
    name: "Jagtial",
    state: "Telangana",
    lat: 18.8,
    lng: 78.93,
  },
  {
    id: "344",
    name: "Viluppuram",
    state: "Tamil Nadu",
    lat: 11.9333,
    lng: 79.4833,
  },
  {
    id: "345",
    name: "Amalner",
    state: "Maharashtra",
    lat: 21.05,
    lng: 75.05,
  },
  {
    id: "346",
    name: "Zirakpur",
    state: "Punjab",
    lat: 30.6425,
    lng: 76.8172,
  },
  {
    id: "347",
    name: "Tanda",
    state: "Uttar Pradesh",
    lat: 26.55,
    lng: 82.65,
  },
  {
    id: "348",
    name: "Tiruchengode",
    state: "Tamil Nadu",
    lat: 11.38,
    lng: 77.9,
  },
  {
    id: "349",
    name: "Nagina",
    state: "Uttar Pradesh",
    lat: 29.45,
    lng: 78.45,
  },
  {
    id: "350",
    name: "Yemmiganur",
    state: "Andhra Pradesh",
    lat: 15.75,
    lng: 77.4833,
  },
  {
    id: "351",
    name: "Vaniyambadi",
    state: "Tamil Nadu",
    lat: 12.6833,
    lng: 78.6167,
  },
  {
    id: "352",
    name: "Sarni",
    state: "Madhya Pradesh",
    lat: 22.1,
    lng: 78.17,
  },
  {
    id: "353",
    name: "Theni Allinagaram",
    state: "Tamil Nadu",
    lat: 10.01,
    lng: 77.48,
  },
  {
    id: "354",
    name: "Margao",
    state: "Goa",
    lat: 15.3,
    lng: 73.95,
  },
  {
    id: "355",
    name: "Akot",
    state: "Maharashtra",
    lat: 21.1,
    lng: 77.05,
  },
  {
    id: "356",
    name: "Sehore",
    state: "Madhya Pradesh",
    lat: 23.2,
    lng: 77.08,
  },
  {
    id: "357",
    name: "Mhow Cantonment",
    state: "Madhya Pradesh",
    lat: 22.5536,
    lng: 75.7583,
  },
  {
    id: "358",
    name: "Kot Kapura",
    state: "Punjab",
    lat: 30.58,
    lng: 74.82,
  },
  {
    id: "359",
    name: "Makrana",
    state: "Rajasthan",
    lat: 27.05,
    lng: 74.72,
  },
  {
    id: "360",
    name: "Pandharpur",
    state: "Maharashtra",
    lat: 17.67,
    lng: 75.33,
  },
  {
    id: "361",
    name: "Miryalaguda",
    state: "Telangana",
    lat: 16.87,
    lng: 79.57,
  },
  {
    id: "362",
    name: "Shamli",
    state: "Uttar Pradesh",
    lat: 29.45,
    lng: 77.32,
  },
  {
    id: "363",
    name: "Seoni",
    state: "Madhya Pradesh",
    lat: 22.1,
    lng: 79.55,
  },
  {
    id: "364",
    name: "Ranibennur",
    state: "Karnataka",
    lat: 14.62,
    lng: 75.63,
  },
  {
    id: "365",
    name: "Kadiri",
    state: "Andhra Pradesh",
    lat: 14.12,
    lng: 78.17,
  },
  {
    id: "366",
    name: "Shrirampur",
    state: "Maharashtra",
    lat: 19.62,
    lng: 74.65,
  },
  {
    id: "367",
    name: "Rudrapur",
    state: "Uttarakhand",
    lat: 28.98,
    lng: 79.4,
  },
  {
    id: "368",
    name: "Parli",
    state: "Maharashtra",
    lat: 18.85,
    lng: 76.53,
  },
  {
    id: "369",
    name: "Najibabad",
    state: "Uttar Pradesh",
    lat: 29.62,
    lng: 78.33,
  },
  {
    id: "370",
    name: "Nirmal",
    state: "Telangana",
    lat: 19.1,
    lng: 78.35,
  },
  {
    id: "371",
    name: "Udhagamandalam",
    state: "Tamil Nadu",
    lat: 11.41,
    lng: 76.7,
  },
  {
    id: "372",
    name: "Shikohabad",
    state: "Uttar Pradesh",
    lat: 27.1,
    lng: 78.6,
  },
  {
    id: "373",
    name: "Jhumri Tilaiya",
    state: "Jharkhand",
    lat: 24.43,
    lng: 85.53,
  },
  {
    id: "374",
    name: "Aruppukkottai",
    state: "Tamil Nadu",
    lat: 9.52,
    lng: 78.1,
  },
  {
    id: "375",
    name: "Ponnani",
    state: "Kerala",
    lat: 10.77,
    lng: 75.9,
  },
  {
    id: "376",
    name: "Jamui",
    state: "Bihar",
    lat: 24.92,
    lng: 86.22,
  },
  {
    id: "377",
    name: "Sitamarhi",
    state: "Bihar",
    lat: 26.6,
    lng: 85.48,
  },
  {
    id: "378",
    name: "Chirala",
    state: "Andhra Pradesh",
    lat: 15.82,
    lng: 80.35,
  },
  {
    id: "379",
    name: "Anjar",
    state: "Gujarat",
    lat: 23.13,
    lng: 70.02,
  },
  {
    id: "380",
    name: "Karaikal",
    state: "Puducherry",
    lat: 10.92,
    lng: 79.83,
  },
  {
    id: "381",
    name: "Hansi",
    state: "Haryana",
    lat: 29.1,
    lng: 75.97,
  },
  {
    id: "382",
    name: "Anakapalle",
    state: "Andhra Pradesh",
    lat: 17.68,
    lng: 83.02,
  },
  {
    id: "383",
    name: "Mahasamund",
    state: "Chhattisgarh",
    lat: 21.1,
    lng: 82.1,
  },
  {
    id: "384",
    name: "Faridkot",
    state: "Punjab",
    lat: 30.67,
    lng: 74.76,
  },
  {
    id: "385",
    name: "Saunda",
    state: "Jharkhand",
    lat: 23.65,
    lng: 85.38,
  },
  {
    id: "386",
    name: "Dhoraji",
    state: "Gujarat",
    lat: 21.73,
    lng: 70.45,
  },
  {
    id: "387",
    name: "Paramakudi",
    state: "Tamil Nadu",
    lat: 9.55,
    lng: 78.6,
  },
  {
    id: "388",
    name: "Balaghat",
    state: "Madhya Pradesh",
    lat: 21.8,
    lng: 80.18,
  },
  {
    id: "389",
    name: "Sujangarh",
    state: "Rajasthan",
    lat: 27.7,
    lng: 74.47,
  },
  {
    id: "390",
    name: "Khambhat",
    state: "Gujarat",
    lat: 22.3,
    lng: 72.62,
  },
  {
    id: "391",
    name: "Muktsar",
    state: "Punjab",
    lat: 30.48,
    lng: 74.52,
  },
  {
    id: "392",
    name: "Rajpura",
    state: "Punjab",
    lat: 30.48,
    lng: 76.6,
  },
  {
    id: "393",
    name: "Kavali",
    state: "Andhra Pradesh",
    lat: 14.92,
    lng: 79.99,
  },
  {
    id: "394",
    name: "Dhamtari",
    state: "Chhattisgarh",
    lat: 20.7,
    lng: 81.55,
  },
  {
    id: "395",
    name: "Ashok Nagar",
    state: "Madhya Pradesh",
    lat: 24.58,
    lng: 77.73,
  },
  {
    id: "396",
    name: "Sardarshahar",
    state: "Rajasthan",
    lat: 28.44,
    lng: 74.49,
  },
  {
    id: "397",
    name: "Mahuva",
    state: "Gujarat",
    lat: 21.09,
    lng: 71.77,
  },
  {
    id: "398",
    name: "Bargarh",
    state: "Odisha",
    lat: 21.33,
    lng: 83.62,
  },
  {
    id: "399",
    name: "Kamareddy",
    state: "Telangana",
    lat: 18.32,
    lng: 78.34,
  },
  {
    id: "400",
    name: "Sahibganj",
    state: "Jharkhand",
    lat: 25.25,
    lng: 87.65,
  },
  {
    id: "401",
    name: "Kothagudem",
    state: "Telangana",
    lat: 17.55,
    lng: 80.63,
  },
  {
    id: "402",
    name: "Ramanagaram",
    state: "Karnataka",
    lat: 12.72,
    lng: 77.3,
  },
  {
    id: "403",
    name: "Gokak",
    state: "Karnataka",
    lat: 16.17,
    lng: 74.83,
  },
  {
    id: "404",
    name: "Tikamgarh",
    state: "Madhya Pradesh",
    lat: 24.75,
    lng: 78.83,
  },
  {
    id: "405",
    name: "Araria",
    state: "Bihar",
    lat: 26.15,
    lng: 87.52,
  },
  {
    id: "406",
    name: "Rishikesh",
    state: "Uttarakhand",
    lat: 30.1086,
    lng: 78.2922,
  },
  {
    id: "407",
    name: "Shahdol",
    state: "Madhya Pradesh",
    lat: 23.3,
    lng: 81.35,
  },
  {
    id: "408",
    name: "Medininagar (Daltonganj)",
    state: "Jharkhand",
    lat: 24.05,
    lng: 84.07,
  },
  {
    id: "409",
    name: "Arakkonam",
    state: "Tamil Nadu",
    lat: 13.08,
    lng: 79.67,
  },
  {
    id: "410",
    name: "Washim",
    state: "Maharashtra",
    lat: 20.1,
    lng: 77.15,
  },
  {
    id: "411",
    name: "Sangrur",
    state: "Punjab",
    lat: 30.25,
    lng: 75.85,
  },
  {
    id: "412",
    name: "Bodhan",
    state: "Telangana",
    lat: 18.67,
    lng: 77.9,
  },
  {
    id: "413",
    name: "Fazilka",
    state: "Punjab",
    lat: 30.4,
    lng: 74.03,
  },
  {
    id: "414",
    name: "Palacole",
    state: "Andhra Pradesh",
    lat: 16.52,
    lng: 81.73,
  },
  {
    id: "415",
    name: "Keshod",
    state: "Gujarat",
    lat: 21.3,
    lng: 70.25,
  },
  {
    id: "416",
    name: "Sullurpeta",
    state: "Andhra Pradesh",
    lat: 13.7,
    lng: 80.02,
  },
  {
    id: "417",
    name: "Wadhwan",
    state: "Gujarat",
    lat: 22.7,
    lng: 71.68,
  },
  {
    id: "418",
    name: "Gurdaspur",
    state: "Punjab",
    lat: 32.04,
    lng: 75.4,
  },
  {
    id: "419",
    name: "Vatakara",
    state: "Kerala",
    lat: 11.6,
    lng: 75.58,
  },
  {
    id: "420",
    name: "Tura",
    state: "Meghalaya",
    lat: 25.52,
    lng: 90.22,
  },
  {
    id: "421",
    name: "Narnaul",
    state: "Haryana",
    lat: 28.05,
    lng: 76.1,
  },
  {
    id: "422",
    name: "Kharar",
    state: "Punjab",
    lat: 30.74,
    lng: 76.65,
  },
  {
    id: "423",
    name: "Yadgir",
    state: "Karnataka",
    lat: 16.77,
    lng: 77.13,
  },
  {
    id: "424",
    name: "Ambejogai",
    state: "Maharashtra",
    lat: 18.73,
    lng: 76.38,
  },
  {
    id: "425",
    name: "Ankleshwar",
    state: "Gujarat",
    lat: 21.62,
    lng: 72.99,
  },
  {
    id: "426",
    name: "Savarkundla",
    state: "Gujarat",
    lat: 21.33,
    lng: 71.3,
  },
  {
    id: "427",
    name: "Paradip",
    state: "Odisha",
    lat: 20.32,
    lng: 86.67,
  },
  {
    id: "428",
    name: "Virudhachalam",
    state: "Tamil Nadu",
    lat: 11.52,
    lng: 79.33,
  },
  {
    id: "429",
    name: "Kanhangad",
    state: "Kerala",
    lat: 12.3,
    lng: 75.1,
  },
  {
    id: "430",
    name: "Kadi",
    state: "Gujarat",
    lat: 23.3,
    lng: 72.33,
  },
  {
    id: "431",
    name: "Srivilliputhur",
    state: "Tamil Nadu",
    lat: 9.52,
    lng: 77.63,
  },
  {
    id: "432",
    name: "Gobindgarh",
    state: "Punjab",
    lat: 30.67,
    lng: 76.3,
  },
  {
    id: "433",
    name: "Tindivanam",
    state: "Tamil Nadu",
    lat: 12.25,
    lng: 79.65,
  },
  {
    id: "434",
    name: "Mansa",
    state: "Punjab",
    lat: 29.99,
    lng: 75.4,
  },
  {
    id: "435",
    name: "Taliparamba",
    state: "Kerala",
    lat: 12.05,
    lng: 75.35,
  },
  {
    id: "436",
    name: "Manmad",
    state: "Maharashtra",
    lat: 20.25,
    lng: 74.44,
  },
  {
    id: "437",
    name: "Tanuku",
    state: "Andhra Pradesh",
    lat: 16.75,
    lng: 81.7,
  },
  {
    id: "438",
    name: "Rayachoti",
    state: "Andhra Pradesh",
    lat: 14.05,
    lng: 78.75,
  },
  {
    id: "439",
    name: "Virudhunagar",
    state: "Tamil Nadu",
    lat: 9.58,
    lng: 77.95,
  },
  {
    id: "440",
    name: "Koyilandy",
    state: "Kerala",
    lat: 11.43,
    lng: 75.7,
  },
  {
    id: "441",
    name: "Jorhat",
    state: "Assam",
    lat: 26.75,
    lng: 94.22,
  },
  {
    id: "442",
    name: "Karur",
    state: "Tamil Nadu",
    lat: 10.95,
    lng: 78.08,
  },
  {
    id: "443",
    name: "Valparai",
    state: "Tamil Nadu",
    lat: 10.32,
    lng: 76.97,
  },
  {
    id: "444",
    name: "Srikalahasti",
    state: "Andhra Pradesh",
    lat: 13.75,
    lng: 79.7,
  },
  {
    id: "445",
    name: "Neyyattinkara",
    state: "Kerala",
    lat: 8.4,
    lng: 77.08,
  },
  {
    id: "446",
    name: "Bapatla",
    state: "Andhra Pradesh",
    lat: 15.9,
    lng: 80.47,
  },
  {
    id: "447",
    name: "Fatehabad",
    state: "Haryana",
    lat: 29.52,
    lng: 75.45,
  },
  {
    id: "448",
    name: "Malout",
    state: "Punjab",
    lat: 30.19,
    lng: 74.5,
  },
  {
    id: "449",
    name: "Sankarankovil",
    state: "Tamil Nadu",
    lat: 9.17,
    lng: 77.55,
  },
  {
    id: "450",
    name: "Tenkasi",
    state: "Tamil Nadu",
    lat: 8.97,
    lng: 77.3,
  },
  {
    id: "451",
    name: "Ratnagiri",
    state: "Maharashtra",
    lat: 16.9944,
    lng: 73.3,
  },
  {
    id: "452",
    name: "Rabkavi Banhatti",
    state: "Karnataka",
    lat: 16.4667,
    lng: 75.1167,
  },
  {
    id: "453",
    name: "Sikandrabad",
    state: "Uttar Pradesh",
    lat: 28.45,
    lng: 77.7,
  },
  {
    id: "454",
    name: "Chaibasa",
    state: "Jharkhand",
    lat: 22.5667,
    lng: 85.8167,
  },
  {
    id: "455",
    name: "Chirmiri",
    state: "Chhattisgarh",
    lat: 23.2,
    lng: 82.35,
  },
  {
    id: "456",
    name: "Palwancha",
    state: "Telangana",
    lat: 17.5833,
    lng: 80.6833,
  },
  {
    id: "457",
    name: "Bhawanipatna",
    state: "Odisha",
    lat: 19.9,
    lng: 83.1667,
  },
  {
    id: "458",
    name: "Kayamkulam",
    state: "Kerala",
    lat: 9.1722,
    lng: 76.5019,
  },
  {
    id: "459",
    name: "Pithampur",
    state: "Madhya Pradesh",
    lat: 22.6167,
    lng: 75.6833,
  },
  {
    id: "460",
    name: "Nabha",
    state: "Punjab",
    lat: 30.375,
    lng: 76.15,
  },
  {
    id: "461",
    name: "Shahabad, Hardoi",
    state: "Uttar Pradesh",
    lat: 27.65,
    lng: 79.95,
  },
  {
    id: "462",
    name: "Dhenkanal",
    state: "Odisha",
    lat: 20.6667,
    lng: 85.6,
  },
  {
    id: "463",
    name: "Uran Islampur",
    state: "Maharashtra",
    lat: 17.05,
    lng: 74.2667,
  },
  {
    id: "464",
    name: "Gopalganj",
    state: "Bihar",
    lat: 26.4667,
    lng: 84.4333,
  },
  {
    id: "465",
    name: "Bongaigaon City",
    state: "Assam",
    lat: 26.4667,
    lng: 90.5667,
  },
  {
    id: "466",
    name: "Palani",
    state: "Tamil Nadu",
    lat: 10.45,
    lng: 77.52,
  },
  {
    id: "467",
    name: "Pusad",
    state: "Maharashtra",
    lat: 19.9,
    lng: 77.5833,
  },
  {
    id: "468",
    name: "Sopore",
    state: "Jammu and Kashmir",
    lat: 34.3,
    lng: 74.47,
  },
  {
    id: "469",
    name: "Pilkhuwa",
    state: "Uttar Pradesh",
    lat: 28.7167,
    lng: 77.65,
  },
  {
    id: "470",
    name: "Tarn Taran",
    state: "Punjab",
    lat: 31.45,
    lng: 74.925,
  },
  {
    id: "471",
    name: "Renukoot",
    state: "Uttar Pradesh",
    lat: 24.2,
    lng: 83.03,
  },
  {
    id: "472",
    name: "Mandamarri",
    state: "Telangana",
    lat: 18.9992,
    lng: 79.4817,
  },
  {
    id: "473",
    name: "Shahabad",
    state: "Karnataka",
    lat: 17.13,
    lng: 76.93,
  },
  {
    id: "474",
    name: "Barbil",
    state: "Odisha",
    lat: 22.1167,
    lng: 85.4,
  },
  {
    id: "475",
    name: "Koratla",
    state: "Telangana",
    lat: 18.82,
    lng: 78.72,
  },
  {
    id: "476",
    name: "Madhubani",
    state: "Bihar",
    lat: 26.37,
    lng: 86.08,
  },
  {
    id: "477",
    name: "Arambagh",
    state: "West Bengal",
    lat: 22.88,
    lng: 87.78,
  },
  {
    id: "478",
    name: "Gohana",
    state: "Haryana",
    lat: 29.13,
    lng: 76.7,
  },
  {
    id: "479",
    name: "Ladnu",
    state: "Rajasthan",
    lat: 27.65,
    lng: 74.38,
  },
  {
    id: "480",
    name: "Pattukkottai",
    state: "Tamil Nadu",
    lat: 10.43,
    lng: 79.32,
  },
  {
    id: "481",
    name: "Sirsi",
    state: "Karnataka",
    lat: 14.62,
    lng: 74.85,
  },
  {
    id: "482",
    name: "Sircilla",
    state: "Telangana",
    lat: 18.38,
    lng: 78.83,
  },
  {
    id: "483",
    name: "Tamluk",
    state: "West Bengal",
    lat: 22.3,
    lng: 87.92,
  },
  {
    id: "484",
    name: "Jagraon",
    state: "Punjab",
    lat: 30.78,
    lng: 75.48,
  },
  {
    id: "485",
    name: "AlipurdUrban Agglomerationr",
    state: "West Bengal",
    lat: 23.62,
    lng: 87.63,
  },
  {
    id: "486",
    name: "Alirajpur",
    state: "Madhya Pradesh",
    lat: 22.3,
    lng: 74.36,
  },
  {
    id: "487",
    name: "Tandur",
    state: "Telangana",
    lat: 17.23,
    lng: 77.58,
  },
  {
    id: "488",
    name: "Naidupet",
    state: "Andhra Pradesh",
    lat: 13.9,
    lng: 79.9,
  },
  {
    id: "489",
    name: "Tirupathur",
    state: "Tamil Nadu",
    lat: 12.5,
    lng: 78.57,
  },
  {
    id: "490",
    name: "Tohana",
    state: "Haryana",
    lat: 29.7,
    lng: 75.9,
  },
  {
    id: "491",
    name: "Ratangarh",
    state: "Rajasthan",
    lat: 28.08,
    lng: 74.6,
  },
  {
    id: "492",
    name: "Dhubri",
    state: "Assam",
    lat: 26.02,
    lng: 90.0,
  },
  {
    id: "493",
    name: "Masaurhi",
    state: "Bihar",
    lat: 25.35,
    lng: 85.03,
  },
  {
    id: "494",
    name: "Visnagar",
    state: "Gujarat",
    lat: 23.7,
    lng: 72.55,
  },
  {
    id: "495",
    name: "Vrindavan",
    state: "Uttar Pradesh",
    lat: 27.58,
    lng: 77.7,
  },
  {
    id: "496",
    name: "Nokha",
    state: "Rajasthan",
    lat: 27.55,
    lng: 73.47,
  },
  {
    id: "497",
    name: "Nagari",
    state: "Andhra Pradesh",
    lat: 13.33,
    lng: 79.58,
  },
  {
    id: "498",
    name: "Narwana",
    state: "Haryana",
    lat: 29.6,
    lng: 76.12,
  },
  {
    id: "499",
    name: "Ramanathapuram",
    state: "Tamil Nadu",
    lat: 9.37,
    lng: 78.83,
  },
  {
    id: "500",
    name: "Ujhani",
    state: "Uttar Pradesh",
    lat: 28.0,
    lng: 79.01,
  },
  {
    id: "501",
    name: "Samastipur",
    state: "Bihar",
    lat: 25.85,
    lng: 85.78,
  },
  {
    id: "502",
    name: "Laharpur",
    state: "Uttar Pradesh",
    lat: 27.7,
    lng: 80.9,
  },
  {
    id: "503",
    name: "Sangamner",
    state: "Maharashtra",
    lat: 19.58,
    lng: 74.2,
  },
  {
    id: "504",
    name: "Nimbahera",
    state: "Rajasthan",
    lat: 24.62,
    lng: 74.68,
  },
  {
    id: "505",
    name: "Siddipet",
    state: "Telangana",
    lat: 18.1,
    lng: 78.85,
  },
  {
    id: "506",
    name: "Suri",
    state: "West Bengal",
    lat: 23.9167,
    lng: 87.5333,
  },
  {
    id: "507",
    name: "Diphu",
    state: "Assam",
    lat: 25.83,
    lng: 93.43,
  },
  {
    id: "508",
    name: "Jhargram",
    state: "West Bengal",
    lat: 22.45,
    lng: 86.98,
  },
  {
    id: "509",
    name: "Shirpur-Warwade",
    state: "Maharashtra",
    lat: 21.35,
    lng: 74.88,
  },
  {
    id: "510",
    name: "Tilhar",
    state: "Uttar Pradesh",
    lat: 27.97,
    lng: 79.73,
  },
  {
    id: "511",
    name: "Sindhnur",
    state: "Karnataka",
    lat: 15.78,
    lng: 76.77,
  },
  {
    id: "512",
    name: "Udumalaipettai",
    state: "Tamil Nadu",
    lat: 10.58,
    lng: 77.25,
  },
  {
    id: "513",
    name: "Malkapur",
    state: "Maharashtra",
    lat: 20.88,
    lng: 76.2,
  },
  {
    id: "514",
    name: "Wanaparthy",
    state: "Telangana",
    lat: 16.3667,
    lng: 78.0667,
  },
  {
    id: "515",
    name: "Gudur",
    state: "Andhra Pradesh",
    lat: 14.15,
    lng: 79.85,
  },
  {
    id: "516",
    name: "Kendujhar",
    state: "Odisha",
    lat: 21.5,
    lng: 85.5,
  },
  {
    id: "517",
    name: "Mandla",
    state: "Madhya Pradesh",
    lat: 22.6,
    lng: 80.38,
  },
  {
    id: "518",
    name: "Mandi",
    state: "Himachal Pradesh",
    lat: 31.71,
    lng: 76.93,
  },
  {
    id: "519",
    name: "Nedumangad",
    state: "Kerala",
    lat: 8.6,
    lng: 77.0,
  },
  {
    id: "520",
    name: "North Lakhimpur",
    state: "Assam",
    lat: 27.23,
    lng: 94.1,
  },
  {
    id: "521",
    name: "Vinukonda",
    state: "Andhra Pradesh",
    lat: 16.05,
    lng: 79.75,
  },
  {
    id: "522",
    name: "Tiptur",
    state: "Karnataka",
    lat: 13.26,
    lng: 76.48,
  },
  {
    id: "523",
    name: "Gobichettipalayam",
    state: "Tamil Nadu",
    lat: 11.45,
    lng: 77.43,
  },
  {
    id: "524",
    name: "Sunabeda",
    state: "Odisha",
    lat: 22.47,
    lng: 82.68,
  },
  {
    id: "525",
    name: "Wani",
    state: "Maharashtra",
    lat: 20.05,
    lng: 78.95,
  },
  {
    id: "526",
    name: "Upleta",
    state: "Gujarat",
    lat: 21.73,
    lng: 70.28,
  },
  {
    id: "527",
    name: "Narasapuram",
    state: "Andhra Pradesh",
    lat: 16.4333,
    lng: 81.6833,
  },
  {
    id: "528",
    name: "Nuzvid",
    state: "Andhra Pradesh",
    lat: 16.78,
    lng: 80.85,
  },
  {
    id: "529",
    name: "Tezpur",
    state: "Assam",
    lat: 26.6333,
    lng: 92.8,
  },
  {
    id: "530",
    name: "Una",
    state: "Gujarat",
    lat: 20.82,
    lng: 71.03,
  },
  {
    id: "531",
    name: "Markapur",
    state: "Andhra Pradesh",
    lat: 15.73,
    lng: 79.27,
  },
  {
    id: "532",
    name: "Sheopur",
    state: "Madhya Pradesh",
    lat: 25.67,
    lng: 76.7,
  },
  {
    id: "533",
    name: "Thiruvarur",
    state: "Tamil Nadu",
    lat: 10.77,
    lng: 79.65,
  },
  {
    id: "534",
    name: "Sidhpur",
    state: "Gujarat",
    lat: 23.92,
    lng: 72.38,
  },
  {
    id: "535",
    name: "Sahaswan",
    state: "Uttar Pradesh",
    lat: 28.07,
    lng: 78.75,
  },
  {
    id: "536",
    name: "Suratgarh",
    state: "Rajasthan",
    lat: 29.32,
    lng: 73.9,
  },
  {
    id: "537",
    name: "Shajapur",
    state: "Madhya Pradesh",
    lat: 23.43,
    lng: 76.27,
  },
  {
    id: "538",
    name: "Rayagada",
    state: "Odisha",
    lat: 19.17,
    lng: 83.42,
  },
  {
    id: "539",
    name: "Lonavla",
    state: "Maharashtra",
    lat: 18.75,
    lng: 73.41,
  },
  {
    id: "540",
    name: "Ponnur",
    state: "Andhra Pradesh",
    lat: 16.0667,
    lng: 80.5667,
  },
  {
    id: "541",
    name: "Kagaznagar",
    state: "Telangana",
    lat: 19.33,
    lng: 79.47,
  },
  {
    id: "542",
    name: "Gadwal",
    state: "Telangana",
    lat: 16.23,
    lng: 77.8,
  },
  {
    id: "543",
    name: "Bhatapara",
    state: "Chhattisgarh",
    lat: 21.73,
    lng: 81.9,
  },
  {
    id: "544",
    name: "Kandukur",
    state: "Andhra Pradesh",
    lat: 15.22,
    lng: 79.9,
  },
  {
    id: "545",
    name: "Sangareddy",
    state: "Telangana",
    lat: 17.63,
    lng: 78.08,
  },
  {
    id: "546",
    name: "Unjha",
    state: "Gujarat",
    lat: 23.8,
    lng: 72.4,
  },
  {
    id: "547",
    name: "Lunglei",
    state: "Mizoram",
    lat: 22.88,
    lng: 92.73,
  },
  {
    id: "548",
    name: "Karimganj",
    state: "Assam",
    lat: 24.86,
    lng: 92.35,
  },
  {
    id: "549",
    name: "Kannur",
    state: "Kerala",
    lat: 11.87,
    lng: 75.37,
  },
  {
    id: "550",
    name: "Bobbili",
    state: "Andhra Pradesh",
    lat: 18.5667,
    lng: 83.4167,
  },
  {
    id: "551",
    name: "Mokameh",
    state: "Bihar",
    lat: 25.4,
    lng: 85.92,
  },
  {
    id: "552",
    name: "Talegaon Dabhade",
    state: "Maharashtra",
    lat: 18.73,
    lng: 73.68,
  },
  {
    id: "553",
    name: "Anjangaon",
    state: "Maharashtra",
    lat: 21.16,
    lng: 77.31,
  },
  {
    id: "554",
    name: "Mangrol",
    state: "Gujarat",
    lat: 21.12,
    lng: 70.12,
  },
  {
    id: "555",
    name: "Sunam",
    state: "Punjab",
    lat: 30.13,
    lng: 75.8,
  },
  {
    id: "556",
    name: "Gangarampur",
    state: "West Bengal",
    lat: 25.4,
    lng: 88.52,
  },
  {
    id: "557",
    name: "Thiruvallur",
    state: "Tamil Nadu",
    lat: 13.13,
    lng: 79.9,
  },
  {
    id: "558",
    name: "Tirur",
    state: "Kerala",
    lat: 10.9,
    lng: 75.92,
  },
  {
    id: "559",
    name: "Rath",
    state: "Uttar Pradesh",
    lat: 25.58,
    lng: 79.57,
  },
  {
    id: "560",
    name: "Jatani",
    state: "Odisha",
    lat: 20.17,
    lng: 85.7,
  },
  {
    id: "561",
    name: "Viramgam",
    state: "Gujarat",
    lat: 23.12,
    lng: 72.03,
  },
  {
    id: "562",
    name: "Rajsamand",
    state: "Rajasthan",
    lat: 25.07,
    lng: 73.88,
  },
  {
    id: "563",
    name: "Yanam",
    state: "Puducherry",
    lat: 16.73,
    lng: 82.22,
  },
  {
    id: "564",
    name: "Kottayam",
    state: "Kerala",
    lat: 9.59,
    lng: 76.52,
  },
  {
    id: "565",
    name: "Panruti",
    state: "Tamil Nadu",
    lat: 11.77,
    lng: 79.55,
  },
  {
    id: "566",
    name: "Dhuri",
    state: "Punjab",
    lat: 30.37,
    lng: 75.87,
  },
  {
    id: "567",
    name: "Namakkal",
    state: "Tamil Nadu",
    lat: 11.23,
    lng: 78.17,
  },
  {
    id: "568",
    name: "Kasaragod",
    state: "Kerala",
    lat: 12.5,
    lng: 74.99,
  },
  {
    id: "569",
    name: "Modasa",
    state: "Gujarat",
    lat: 23.45,
    lng: 73.3,
  },
  {
    id: "570",
    name: "Rayadurg",
    state: "Andhra Pradesh",
    lat: 14.7,
    lng: 76.87,
  },
  {
    id: "571",
    name: "Supaul",
    state: "Bihar",
    lat: 26.12,
    lng: 86.6,
  },
  {
    id: "572",
    name: "Kunnamkulam",
    state: "Kerala",
    lat: 10.65,
    lng: 76.08,
  },
  {
    id: "573",
    name: "Umred",
    state: "Maharashtra",
    lat: 20.85,
    lng: 79.33,
  },
  {
    id: "574",
    name: "Bellampalle",
    state: "Telangana",
    lat: 19.05,
    lng: 79.5,
  },
  {
    id: "575",
    name: "Sibsagar",
    state: "Assam",
    lat: 26.98,
    lng: 94.63,
  },
  {
    id: "576",
    name: "Mandi Dabwali",
    state: "Haryana",
    lat: 29.95,
    lng: 74.73,
  },
  {
    id: "577",
    name: "Ottappalam",
    state: "Kerala",
    lat: 10.77,
    lng: 76.38,
  },
  {
    id: "578",
    name: "Dumraon",
    state: "Bihar",
    lat: 25.55,
    lng: 84.15,
  },
  {
    id: "579",
    name: "Samalkot",
    state: "Andhra Pradesh",
    lat: 17.05,
    lng: 82.18,
  },
  {
    id: "580",
    name: "Jaggaiahpet",
    state: "Andhra Pradesh",
    lat: 16.89,
    lng: 80.1,
  },
  {
    id: "581",
    name: "Goalpara",
    state: "Assam",
    lat: 26.17,
    lng: 90.63,
  },
  {
    id: "582",
    name: "Tuni",
    state: "Andhra Pradesh",
    lat: 17.35,
    lng: 82.55,
  },
  {
    id: "583",
    name: "Lachhmangarh",
    state: "Rajasthan",
    lat: 27.82,
    lng: 75.03,
  },
  {
    id: "584",
    name: "Bhongir",
    state: "Telangana",
    lat: 17.52,
    lng: 78.88,
  },
  {
    id: "585",
    name: "Amalapuram",
    state: "Andhra Pradesh",
    lat: 16.58,
    lng: 82.02,
  },
  {
    id: "586",
    name: "Firozpur Cantt.",
    state: "Punjab",
    lat: 30.95,
    lng: 74.6,
  },
  {
    id: "587",
    name: "Vikarabad",
    state: "Telangana",
    lat: 17.33,
    lng: 77.9,
  },
  {
    id: "588",
    name: "Thiruvalla",
    state: "Kerala",
    lat: 9.38,
    lng: 76.57,
  },
  {
    id: "589",
    name: "Sherkot",
    state: "Uttar Pradesh",
    lat: 29.35,
    lng: 78.58,
  },
  {
    id: "590",
    name: "Palghar",
    state: "Maharashtra",
    lat: 19.7,
    lng: 72.77,
  },
  {
    id: "591",
    name: "Shegaon",
    state: "Maharashtra",
    lat: 20.79,
    lng: 76.69,
  },
  {
    id: "592",
    name: "Jangaon",
    state: "Telangana",
    lat: 17.72,
    lng: 79.18,
  },
  {
    id: "593",
    name: "Bheemunipatnam",
    state: "Andhra Pradesh",
    lat: 17.89,
    lng: 83.43,
  },
  {
    id: "594",
    name: "Panna",
    state: "Madhya Pradesh",
    lat: 24.72,
    lng: 80.2,
  },
  {
    id: "595",
    name: "Thodupuzha",
    state: "Kerala",
    lat: 9.9,
    lng: 76.72,
  },
  {
    id: "596",
    name: "KathUrban Agglomeration",
    state: "Jammu and Kashmir",
    lat: 32.37,
    lng: 75.52,
  },
  {
    id: "597",
    name: "Palitana",
    state: "Gujarat",
    lat: 21.52,
    lng: 71.83,
  },
  {
    id: "598",
    name: "Arwal",
    state: "Bihar",
    lat: 25.25,
    lng: 84.68,
  },
  {
    id: "599",
    name: "Venkatagiri",
    state: "Andhra Pradesh",
    lat: 13.97,
    lng: 79.58,
  },
  {
    id: "600",
    name: "Kalpi",
    state: "Uttar Pradesh",
    lat: 26.12,
    lng: 79.73,
  },
  {
    id: "601",
    name: "Rajgarh (Churu)",
    state: "Rajasthan",
    lat: 27.25,
    lng: 76.62,
  },
  {
    id: "602",
    name: "Sattenapalle",
    state: "Andhra Pradesh",
    lat: 16.39,
    lng: 80.15,
  },
  {
    id: "603",
    name: "Arsikere",
    state: "Karnataka",
    lat: 13.31,
    lng: 76.26,
  },
  {
    id: "604",
    name: "Ozar",
    state: "Maharashtra",
    lat: 20.09,
    lng: 73.93,
  },
  {
    id: "605",
    name: "Thirumangalam",
    state: "Tamil Nadu",
    lat: 9.85,
    lng: 77.82,
  },
  {
    id: "606",
    name: "Petlad",
    state: "Gujarat",
    lat: 22.47,
    lng: 72.8,
  },
  {
    id: "607",
    name: "Nasirabad",
    state: "Rajasthan",
    lat: 26.3,
    lng: 74.73,
  },
  {
    id: "608",
    name: "Phaltan",
    state: "Maharashtra",
    lat: 17.99,
    lng: 74.43,
  },
  {
    id: "609",
    name: "Rampurhat",
    state: "West Bengal",
    lat: 24.18,
    lng: 87.78,
  },
  {
    id: "610",
    name: "Nanjangud",
    state: "Karnataka",
    lat: 12.12,
    lng: 76.68,
  },
  {
    id: "611",
    name: "Forbesganj",
    state: "Bihar",
    lat: 26.3,
    lng: 87.25,
  },
  {
    id: "612",
    name: "Tundla",
    state: "Uttar Pradesh",
    lat: 27.21,
    lng: 78.28,
  },
  {
    id: "613",
    name: "BhabUrban Agglomeration",
    state: "Bihar",
    lat: 25.18,
    lng: 85.52,
  },
  {
    id: "614",
    name: "Sagara",
    state: "Karnataka",
    lat: 14.16,
    lng: 75.03,
  },
  {
    id: "615",
    name: "Pithapuram",
    state: "Andhra Pradesh",
    lat: 17.12,
    lng: 82.27,
  },
  {
    id: "616",
    name: "Sira",
    state: "Karnataka",
    lat: 13.75,
    lng: 76.91,
  },
  {
    id: "617",
    name: "Bhadrachalam",
    state: "Telangana",
    lat: 17.67,
    lng: 80.89,
  },
  {
    id: "618",
    name: "Charkhi Dadri",
    state: "Haryana",
    lat: 28.59,
    lng: 76.27,
  },
  {
    id: "619",
    name: "Chatra",
    state: "Jharkhand",
    lat: 24.21,
    lng: 84.87,
  },
  {
    id: "620",
    name: "Palasa Kasibugga",
    state: "Andhra Pradesh",
    lat: 18.77,
    lng: 84.41,
  },
  {
    id: "621",
    name: "Nohar",
    state: "Rajasthan",
    lat: 29.18,
    lng: 74.77,
  },
  {
    id: "622",
    name: "Yevla",
    state: "Maharashtra",
    lat: 19.93,
    lng: 73.67,
  },
  {
    id: "623",
    name: "Sirhind Fatehgarh Sahib",
    state: "Punjab",
    lat: 30.63,
    lng: 76.38,
  },
  {
    id: "624",
    name: "Bhainsa",
    state: "Telangana",
    lat: 19.1,
    lng: 77.97,
  },
  {
    id: "625",
    name: "Parvathipuram",
    state: "Andhra Pradesh",
    lat: 18.78,
    lng: 83.43,
  },
  {
    id: "626",
    name: "Shahade",
    state: "Maharashtra",
    lat: 21.55,
    lng: 74.47,
  },
  {
    id: "627",
    name: "Chalakudy",
    state: "Kerala",
    lat: 10.31,
    lng: 76.34,
  },
  {
    id: "628",
    name: "Narkatiaganj",
    state: "Bihar",
    lat: 27.11,
    lng: 84.46,
  },
  {
    id: "629",
    name: "Kapadvanj",
    state: "Gujarat",
    lat: 23.02,
    lng: 73.07,
  },
  {
    id: "630",
    name: "Macherla",
    state: "Andhra Pradesh",
    lat: 16.48,
    lng: 79.43,
  },
  {
    id: "631",
    name: "Raghogarh-Vijaypur",
    state: "Madhya Pradesh",
    lat: 24.45,
    lng: 77.2,
  },
  {
    id: "632",
    name: "Rupnagar",
    state: "Punjab",
    lat: 30.97,
    lng: 76.53,
  },
  {
    id: "633",
    name: "Naugachhia",
    state: "Bihar",
    lat: 25.39,
    lng: 87.1,
  },
  {
    id: "634",
    name: "Sendhwa",
    state: "Madhya Pradesh",
    lat: 21.68,
    lng: 75.1,
  },
  {
    id: "635",
    name: "Byasanagar",
    state: "Odisha",
    lat: 20.93,
    lng: 86.12,
  },
  {
    id: "636",
    name: "Sandila",
    state: "Uttar Pradesh",
    lat: 27.08,
    lng: 80.52,
  },
  {
    id: "637",
    name: "Gooty",
    state: "Andhra Pradesh",
    lat: 15.12,
    lng: 77.63,
  },
  {
    id: "638",
    name: "Salur",
    state: "Andhra Pradesh",
    lat: 18.53,
    lng: 83.21,
  },
  {
    id: "639",
    name: "Nanpara",
    state: "Uttar Pradesh",
    lat: 27.87,
    lng: 81.5,
  },
  {
    id: "640",
    name: "Sardhana",
    state: "Uttar Pradesh",
    lat: 29.15,
    lng: 77.62,
  },
  {
    id: "641",
    name: "Vita",
    state: "Maharashtra",
    lat: 17.27,
    lng: 74.54,
  },
  {
    id: "642",
    name: "Gumia",
    state: "Jharkhand",
    lat: 23.8,
    lng: 85.82,
  },
  {
    id: "643",
    name: "Puttur",
    state: "Karnataka",
    lat: 12.77,
    lng: 75.22,
  },
  {
    id: "644",
    name: "Jalandhar Cantt.",
    state: "Punjab",
    lat: 31.33,
    lng: 75.58,
  },
  {
    id: "645",
    name: "Nehtaur",
    state: "Uttar Pradesh",
    lat: 29.32,
    lng: 78.39,
  },
  {
    id: "646",
    name: "Changanassery",
    state: "Kerala",
    lat: 9.46,
    lng: 76.55,
  },
  {
    id: "647",
    name: "Mandapeta",
    state: "Andhra Pradesh",
    lat: 16.87,
    lng: 81.93,
  },
  {
    id: "648",
    name: "Dumka",
    state: "Jharkhand",
    lat: 24.27,
    lng: 87.25,
  },
  {
    id: "649",
    name: "Seohara",
    state: "Uttar Pradesh",
    lat: 29.21,
    lng: 78.59,
  },
  {
    id: "650",
    name: "Umarkhed",
    state: "Maharashtra",
    lat: 19.6,
    lng: 77.7,
  },
  {
    id: "651",
    name: "Madhupur",
    state: "Jharkhand",
    lat: 24.27,
    lng: 86.65,
  },
  {
    id: "652",
    name: "Vikramasingapuram",
    state: "Tamil Nadu",
    lat: 8.67,
    lng: 77.37,
  },
  {
    id: "653",
    name: "Punalur",
    state: "Kerala",
    lat: 9.0,
    lng: 76.93,
  },
  {
    id: "654",
    name: "Kendrapara",
    state: "Odisha",
    lat: 20.5,
    lng: 86.42,
  },
  {
    id: "655",
    name: "Sihor",
    state: "Gujarat",
    lat: 21.7,
    lng: 71.97,
  },
  {
    id: "656",
    name: "Nellikuppam",
    state: "Tamil Nadu",
    lat: 11.77,
    lng: 79.67,
  },
  {
    id: "657",
    name: "Samana",
    state: "Punjab",
    lat: 30.15,
    lng: 76.2,
  },
  {
    id: "658",
    name: "Warora",
    state: "Maharashtra",
    lat: 20.23,
    lng: 79.0,
  },
  {
    id: "659",
    name: "Nilambur",
    state: "Kerala",
    lat: 11.28,
    lng: 76.24,
  },
  {
    id: "660",
    name: "Rasipuram",
    state: "Tamil Nadu",
    lat: 11.47,
    lng: 78.17,
  },
  {
    id: "661",
    name: "Ramnagar",
    state: "Uttarakhand",
    lat: 29.4,
    lng: 79.12,
  },
  {
    id: "662",
    name: "Jammalamadugu",
    state: "Andhra Pradesh",
    lat: 14.85,
    lng: 78.38,
  },
  {
    id: "663",
    name: "Nawanshahr",
    state: "Punjab",
    lat: 31.12,
    lng: 76.13,
  },
  {
    id: "664",
    name: "Thoubal",
    state: "Manipur",
    lat: 24.63,
    lng: 94.02,
  },
  {
    id: "665",
    name: "Athni",
    state: "Karnataka",
    lat: 16.73,
    lng: 75.07,
  },
  {
    id: "666",
    name: "Cherthala",
    state: "Kerala",
    lat: 9.68,
    lng: 76.34,
  },
  {
    id: "667",
    name: "Sidhi",
    state: "Madhya Pradesh",
    lat: 24.42,
    lng: 81.88,
  },
  {
    id: "668",
    name: "Farooqnagar",
    state: "Telangana",
    lat: 17.08,
    lng: 78.2,
  },
  {
    id: "669",
    name: "Peddapuram",
    state: "Andhra Pradesh",
    lat: 17.08,
    lng: 82.13,
  },
  {
    id: "670",
    name: "Chirkunda",
    state: "Jharkhand",
    lat: 23.73,
    lng: 86.75,
  },
  {
    id: "671",
    name: "Pachora",
    state: "Maharashtra",
    lat: 20.67,
    lng: 75.35,
  },
  {
    id: "672",
    name: "Madhepura",
    state: "Bihar",
    lat: 25.92,
    lng: 86.78,
  },
  {
    id: "673",
    name: "Pithoragarh",
    state: "Uttarakhand",
    lat: 29.58,
    lng: 80.22,
  },
  {
    id: "674",
    name: "Tumsar",
    state: "Maharashtra",
    lat: 21.38,
    lng: 79.73,
  },
  {
    id: "675",
    name: "Phalodi",
    state: "Rajasthan",
    lat: 27.13,
    lng: 72.37,
  },
  {
    id: "676",
    name: "Tiruttani",
    state: "Tamil Nadu",
    lat: 13.18,
    lng: 79.63,
  },
  {
    id: "677",
    name: "Rampura Phul",
    state: "Punjab",
    lat: 30.27,
    lng: 75.24,
  },
  {
    id: "678",
    name: "Perinthalmanna",
    state: "Kerala",
    lat: 10.98,
    lng: 76.23,
  },
  {
    id: "679",
    name: "Padrauna",
    state: "Uttar Pradesh",
    lat: 26.9,
    lng: 83.98,
  },
  {
    id: "680",
    name: "Pipariya",
    state: "Madhya Pradesh",
    lat: 22.75,
    lng: 78.35,
  },
  {
    id: "681",
    name: "Dalli-Rajhara",
    state: "Chhattisgarh",
    lat: 20.58,
    lng: 80.52,
  },
  {
    id: "682",
    name: "Punganur",
    state: "Andhra Pradesh",
    lat: 13.37,
    lng: 78.58,
  },
  {
    id: "683",
    name: "Mattannur",
    state: "Kerala",
    lat: 11.93,
    lng: 75.58,
  },
  {
    id: "684",
    name: "Mathura",
    state: "Uttar Pradesh",
    lat: 27.5,
    lng: 77.68,
  },
  {
    id: "685",
    name: "Thakurdwara",
    state: "Uttar Pradesh",
    lat: 29.2,
    lng: 78.85,
  },
  {
    id: "686",
    name: "Nandivaram-Guduvancheri",
    state: "Tamil Nadu",
    lat: 12.84,
    lng: 80.06,
  },
  {
    id: "687",
    name: "Mulbagal",
    state: "Karnataka",
    lat: 13.17,
    lng: 78.4,
  },
  {
    id: "688",
    name: "Manjlegaon",
    state: "Maharashtra",
    lat: 19.15,
    lng: 76.23,
  },
  {
    id: "689",
    name: "Wankaner",
    state: "Gujarat",
    lat: 22.62,
    lng: 70.93,
  },
  {
    id: "690",
    name: "Sillod",
    state: "Maharashtra",
    lat: 20.3,
    lng: 75.65,
  },
  {
    id: "691",
    name: "Nidadavole",
    state: "Andhra Pradesh",
    lat: 16.92,
    lng: 81.67,
  },
  {
    id: "692",
    name: "Surapura",
    state: "Karnataka",
    lat: 16.82,
    lng: 77.17,
  },
  {
    id: "693",
    name: "Rajagangapur",
    state: "Odisha",
    lat: 22.2,
    lng: 84.58,
  },
  {
    id: "694",
    name: "Sheikhpura",
    state: "Bihar",
    lat: 25.13,
    lng: 85.85,
  },
  {
    id: "695",
    name: "Parlakhemundi",
    state: "Odisha",
    lat: 18.78,
    lng: 84.08,
  },
  {
    id: "696",
    name: "Kalimpong",
    state: "West Bengal",
    lat: 27.06,
    lng: 88.47,
  },
  {
    id: "697",
    name: "Siruguppa",
    state: "Karnataka",
    lat: 15.63,
    lng: 76.9,
  },
  {
    id: "698",
    name: "Arvi",
    state: "Maharashtra",
    lat: 20.98,
    lng: 78.23,
  },
  {
    id: "699",
    name: "Limbdi",
    state: "Gujarat",
    lat: 22.57,
    lng: 71.8,
  },
  {
    id: "700",
    name: "Barpeta",
    state: "Assam",
    lat: 26.32,
    lng: 91.0,
  },
  {
    id: "701",
    name: "Manglaur",
    state: "Uttarakhand",
    lat: 29.8,
    lng: 77.87,
  },
  {
    id: "702",
    name: "Repalle",
    state: "Andhra Pradesh",
    lat: 16.02,
    lng: 80.85,
  },
  {
    id: "703",
    name: "Mudhol",
    state: "Karnataka",
    lat: 16.35,
    lng: 75.28,
  },
  {
    id: "704",
    name: "Shujalpur",
    state: "Madhya Pradesh",
    lat: 23.4,
    lng: 76.72,
  },
  {
    id: "705",
    name: "Mandvi",
    state: "Gujarat",
    lat: 22.83,
    lng: 69.35,
  },
  {
    id: "706",
    name: "Thangadh",
    state: "Gujarat",
    lat: 22.57,
    lng: 71.18,
  },
  {
    id: "707",
    name: "Sironj",
    state: "Madhya Pradesh",
    lat: 24.1,
    lng: 77.7,
  },
  {
    id: "708",
    name: "Nandura",
    state: "Maharashtra",
    lat: 20.83,
    lng: 76.46,
  },
  {
    id: "709",
    name: "Shoranur",
    state: "Kerala",
    lat: 10.77,
    lng: 76.28,
  },
  {
    id: "710",
    name: "Nathdwara",
    state: "Rajasthan",
    lat: 24.93,
    lng: 73.82,
  },
  {
    id: "711",
    name: "Periyakulam",
    state: "Tamil Nadu",
    lat: 10.12,
    lng: 77.55,
  },
  {
    id: "712",
    name: "Sultanganj",
    state: "Bihar",
    lat: 25.25,
    lng: 86.73,
  },
  {
    id: "713",
    name: "Medak",
    state: "Telangana",
    lat: 18.03,
    lng: 78.27,
  },
  {
    id: "714",
    name: "Narayanpet",
    state: "Telangana",
    lat: 16.75,
    lng: 77.5,
  },
  {
    id: "715",
    name: "Raxaul Bazar",
    state: "Bihar",
    lat: 26.98,
    lng: 84.85,
  },
  {
    id: "716",
    name: "Rajauri",
    state: "Jammu and Kashmir",
    lat: 33.38,
    lng: 74.3,
  },
  {
    id: "717",
    name: "Pernampattu",
    state: "Tamil Nadu",
    lat: 12.93,
    lng: 78.72,
  },
  {
    id: "718",
    name: "Nainital",
    state: "Uttarakhand",
    lat: 29.38,
    lng: 79.45,
  },
  {
    id: "719",
    name: "Ramachandrapuram",
    state: "Andhra Pradesh",
    lat: 16.85,
    lng: 82.02,
  },
  {
    id: "720",
    name: "Vaijapur",
    state: "Maharashtra",
    lat: 19.92,
    lng: 74.73,
  },
  {
    id: "721",
    name: "Nangal",
    state: "Punjab",
    lat: 31.37,
    lng: 76.38,
  },
  {
    id: "722",
    name: "Sidlaghatta",
    state: "Karnataka",
    lat: 13.39,
    lng: 77.86,
  },
  {
    id: "723",
    name: "Punch",
    state: "Jammu and Kashmir",
    lat: 33.77,
    lng: 74.1,
  },
  {
    id: "724",
    name: "Pandhurna",
    state: "Madhya Pradesh",
    lat: 21.6,
    lng: 78.52,
  },
  {
    id: "725",
    name: "Wadgaon Road",
    state: "Maharashtra",
    lat: 18.75,
    lng: 73.65,
  },
  {
    id: "726",
    name: "Talcher",
    state: "Odisha",
    lat: 20.95,
    lng: 85.22,
  },
  {
    id: "727",
    name: "Varkala",
    state: "Kerala",
    lat: 8.73,
    lng: 76.71,
  },
  {
    id: "728",
    name: "Pilani",
    state: "Rajasthan",
    lat: 28.37,
    lng: 75.6,
  },
  {
    id: "729",
    name: "Nowgong",
    state: "Madhya Pradesh",
    lat: 24.53,
    lng: 77.93,
  },
  {
    id: "730",
    name: "Naila Janjgir",
    state: "Chhattisgarh",
    lat: 22.18,
    lng: 82.55,
  },
  {
    id: "731",
    name: "Mapusa",
    state: "Goa",
    lat: 15.6,
    lng: 73.82,
  },
  {
    id: "732",
    name: "Vellakoil",
    state: "Tamil Nadu",
    lat: 10.95,
    lng: 77.72,
  },
  {
    id: "733",
    name: "Merta City",
    state: "Rajasthan",
    lat: 26.65,
    lng: 74.03,
  },
  {
    id: "734",
    name: "Sivaganga",
    state: "Tamil Nadu",
    lat: 9.87,
    lng: 78.48,
  },
  {
    id: "735",
    name: "Mandideep",
    state: "Madhya Pradesh",
    lat: 23.08,
    lng: 77.53,
  },
  {
    id: "736",
    name: "Sailu",
    state: "Maharashtra",
    lat: 19.47,
    lng: 76.47,
  },
  {
    id: "737",
    name: "Vyara",
    state: "Gujarat",
    lat: 21.12,
    lng: 73.4,
  },
  {
    id: "738",
    name: "Kovvur",
    state: "Andhra Pradesh",
    lat: 17.02,
    lng: 81.73,
  },
  {
    id: "739",
    name: "Vadalur",
    state: "Tamil Nadu",
    lat: 11.58,
    lng: 79.57,
  },
  {
    id: "740",
    name: "Nawabganj",
    state: "Uttar Pradesh",
    lat: 26.93,
    lng: 81.2,
  },
  {
    id: "741",
    name: "Padra",
    state: "Gujarat",
    lat: 22.24,
    lng: 73.08,
  },
  {
    id: "742",
    name: "Sainthia",
    state: "West Bengal",
    lat: 23.95,
    lng: 87.68,
  },
  {
    id: "743",
    name: "Siana",
    state: "Uttar Pradesh",
    lat: 29.55,
    lng: 77.38,
  },
  {
    id: "744",
    name: "Shahpur",
    state: "Karnataka",
    lat: 16.7,
    lng: 76.83,
  },
  {
    id: "745",
    name: "Sojat",
    state: "Rajasthan",
    lat: 25.92,
    lng: 73.67,
  },
  {
    id: "746",
    name: "Noorpur",
    state: "Uttar Pradesh",
    lat: 29.15,
    lng: 78.42,
  },
  {
    id: "747",
    name: "Paravoor",
    state: "Kerala",
    lat: 8.78,
    lng: 76.7,
  },
  {
    id: "748",
    name: "Murtijapur",
    state: "Maharashtra",
    lat: 20.73,
    lng: 77.37,
  },
  {
    id: "749",
    name: "Ramnagar",
    state: "Bihar",
    lat: 27.17,
    lng: 84.32,
  },
  {
    id: "750",
    name: "Sundargarh",
    state: "Odisha",
    lat: 22.12,
    lng: 84.03,
  },
  { id: "751", name: "Taki", state: "West Bengal", lat: 22.6333, lng: 88.8833 },
  {
    id: "752",
    name: "Saundatti-Yellamma",
    state: "Karnataka",
    lat: 16.3667,
    lng: 74.8833,
  },
  {
    id: "753",
    name: "Pathanamthitta",
    state: "Kerala",
    lat: 9.2667,
    lng: 76.7833,
  },
  { id: "754", name: "Wadi", state: "Karnataka", lat: 17.1833, lng: 77.3667 },
  {
    id: "755",
    name: "Rameshwaram",
    state: "Tamil Nadu",
    lat: 9.2886,
    lng: 79.3128,
  },
  {
    id: "756",
    name: "Tasgaon",
    state: "Maharashtra",
    lat: 17.0833,
    lng: 74.4167,
  },
  {
    id: "757",
    name: "Sikandra Rao",
    state: "Uttar Pradesh",
    lat: 27.5667,
    lng: 78.4167,
  },
  {
    id: "758",
    name: "Sihora",
    state: "Madhya Pradesh",
    lat: 23.4167,
    lng: 80.75,
  },
  {
    id: "759",
    name: "Tiruvethipuram",
    state: "Tamil Nadu",
    lat: 9.2833,
    lng: 77.7667,
  },
  {
    id: "760",
    name: "Tiruvuru",
    state: "Andhra Pradesh",
    lat: 16.9833,
    lng: 80.7667,
  },
  {
    id: "761",
    name: "Mehkar",
    state: "Maharashtra",
    lat: 20.4167,
    lng: 76.1667,
  },
  { id: "762", name: "Peringathur", state: "Kerala", lat: 11.75, lng: 75.5833 },
  {
    id: "763",
    name: "Perambalur",
    state: "Tamil Nadu",
    lat: 11.9167,
    lng: 78.7833,
  },
  { id: "764", name: "Manvi", state: "Karnataka", lat: 16.4167, lng: 77.6167 },
  {
    id: "765",
    name: "Zunheboto",
    state: "Nagaland",
    lat: 26.0333,
    lng: 94.1167,
  },
  {
    id: "766",
    name: "Mahnar Bazar",
    state: "Bihar",
    lat: 25.6333,
    lng: 85.6333,
  },
  { id: "767", name: "Attingal", state: "Kerala", lat: 8.6333, lng: 76.8333 },
  { id: "768", name: "Shahbad", state: "Haryana", lat: 29.6333, lng: 76.85 },
  {
    id: "769",
    name: "Puranpur",
    state: "Uttar Pradesh",
    lat: 28.3667,
    lng: 79.4167,
  },
  {
    id: "770",
    name: "Nelamangala",
    state: "Karnataka",
    lat: 13.0833,
    lng: 77.4167,
  },
  { id: "771", name: "Nakodar", state: "Punjab", lat: 31.1333, lng: 75.5333 },
  { id: "772", name: "Lunawada", state: "Gujarat", lat: 23.0167, lng: 73.0167 },
  {
    id: "773",
    name: "Murshidabad",
    state: "West Bengal",
    lat: 24.1833,
    lng: 88.2833,
  },
  { id: "774", name: "Mahe", state: "Puducherry", lat: 11.8667, lng: 75.5333 },
  { id: "775", name: "Lanka", state: "Assam", lat: 27.0, lng: 94.0 },
  {
    id: "776",
    name: "Rudauli",
    state: "Uttar Pradesh",
    lat: 26.4167,
    lng: 81.4167,
  },
  { id: "777", name: "Tuensang", state: "Nagaland", lat: 26.3, lng: 94.5 },
  {
    id: "778",
    name: "Lakshmeshwar",
    state: "Karnataka",
    lat: 16.4167,
    lng: 75.4167,
  },
  { id: "779", name: "Zira", state: "Punjab", lat: 30.9833, lng: 75.9833 },
  { id: "780", name: "Yawal", state: "Maharashtra", lat: 21.0167, lng: 75.85 },
  {
    id: "781",
    name: "Thana Bhawan",
    state: "Uttar Pradesh",
    lat: 29.4167,
    lng: 77.4167,
  },
  {
    id: "782",
    name: "Ramdurg",
    state: "Karnataka",
    lat: 16.4167,
    lng: 75.4167,
  },
  {
    id: "783",
    name: "Pulgaon",
    state: "Maharashtra",
    lat: 20.4167,
    lng: 78.4167,
  },
  {
    id: "784",
    name: "Sadasivpet",
    state: "Telangana",
    lat: 17.4167,
    lng: 77.4167,
  },
  {
    id: "785",
    name: "Nargund",
    state: "Karnataka",
    lat: 15.4167,
    lng: 75.4167,
  },
  {
    id: "786",
    name: "Neem-Ka-Thana",
    state: "Rajasthan",
    lat: 27.4167,
    lng: 75.4167,
  },
  {
    id: "787",
    name: "Memari",
    state: "West Bengal",
    lat: 23.1833,
    lng: 87.9833,
  },
  {
    id: "788",
    name: "Nilanga",
    state: "Maharashtra",
    latitude: 18.125875,
    longitude: 76.750969,
  },
  {
    id: "789",
    name: "Naharlagun",
    state: "Arunachal Pradesh",
    latitude: 27.1167,
    longitude: 93.7333,
  },
  {
    id: "790",
    name: "Pakaur",
    state: "Jharkhand",
    latitude: 24.6167,
    longitude: 87.8833,
  },
  {
    id: "791",
    name: "Wai",
    state: "Maharashtra",
    latitude: 17.9183,
    longitude: 73.8361,
  },
  {
    id: "792",
    name: "Tarikere",
    state: "Karnataka",
    latitude: 13.7115495,
    longitude: 75.8126083,
  },
  {
    id: "793",
    name: "Malavalli",
    state: "Karnataka",
    latitude: 12.5583,
    longitude: 77.0167,
  },
  {
    id: "794",
    name: "Raisen",
    state: "Madhya Pradesh",
    latitude: 23.326809,
    longitude: 77.78492,
  },
  {
    id: "795",
    name: "Lahar",
    state: "Madhya Pradesh",
    latitude: 26.4167,
    longitude: 78.4167,
  },
  {
    id: "796",
    name: "Uravakonda",
    state: "Andhra Pradesh",
    latitude: 14.9167,
    longitude: 77.4167,
  },
  {
    id: "797",
    name: "Savanur",
    state: "Karnataka",
    latitude: 14.7833,
    longitude: 75.4167,
  },
  {
    id: "798",
    name: "Sirohi",
    state: "Rajasthan",
    latitude: 24.882618,
    longitude: 72.858894,
  },
  {
    id: "799",
    name: "Udhampur",
    state: "Jammu and Kashmir",
    latitude: 32.916534,
    longitude: 75.132607,
  },
  {
    id: "800",
    name: "Umarga",
    state: "Maharashtra",
    latitude: 17.839767,
    longitude: 76.622246,
  },
  {
    id: "801",
    name: "Pratapgarh",
    state: "Rajasthan",
    latitude: 24.07,
    longitude: 74.6194,
  },
  {
    id: "802",
    name: "Lingsugur",
    state: "Karnataka",
    latitude: 16.1667,
    longitude: 76.5833,
  },
  {
    id: "803",
    name: "Usilampatti",
    state: "Tamil Nadu",
    latitude: 9.9167,
    longitude: 77.8333,
  },
  {
    id: "804",
    name: "Palia Kalan",
    state: "Uttar Pradesh",
    latitude: 27.4167,
    longitude: 80.4167,
  },
  {
    id: "805",
    name: "Wokha",
    state: "Nagaland",
    latitude: 26.0,
    longitude: 94.2833,
  },
  {
    id: "806",
    name: "Rajpipla",
    state: "Gujarat",
    latitude: 21.8,
    longitude: 73.3833,
  },
  {
    id: "807",
    name: "Vijayapura",
    state: "Karnataka",
    latitude: 16.8297,
    longitude: 75.71,
  },
  {
    id: "808",
    name: "Rawatbhata",
    state: "Rajasthan",
    latitude: 25.35,
    longitude: 75.55,
  },
  {
    id: "809",
    name: "Sangaria",
    state: "Rajasthan",
    latitude: 29.4167,
    longitude: 74.3667,
  },
  {
    id: "810",
    name: "Paithan",
    state: "Maharashtra",
    latitude: 19.5,
    longitude: 75.4167,
  },
  {
    id: "811",
    name: "Rahuri",
    state: "Maharashtra",
    latitude: 19.2333,
    longitude: 74.5667,
  },
  {
    id: "812",
    name: "Patti",
    state: "Punjab",
    latitude: 31.75,
    longitude: 75.4167,
  },
  {
    id: "813",
    name: "Zaidpur",
    state: "Uttar Pradesh",
    latitude: 26.4167,
    longitude: 81.4167,
  },
  {
    id: "814",
    name: "Lalsot",
    state: "Rajasthan",
    latitude: 26.8333,
    longitude: 76.4333,
  },
  {
    id: "815",
    name: "Maihar",
    state: "Madhya Pradesh",
    latitude: 24.3833,
    longitude: 80.7667,
  },
  {
    id: "816",
    name: "Vedaranyam",
    state: "Tamil Nadu",
    latitude: 10.3833,
    longitude: 79.5667,
  },
  {
    id: "817",
    name: "Nawapur",
    state: "Maharashtra",
    latitude: 20.4167,
    longitude: 74.4167,
  },
  {
    id: "818",
    name: "Solan",
    state: "Himachal Pradesh",
    latitude: 30.9,
    longitude: 77.1,
  },
  {
    id: "819",
    name: "Vapi",
    state: "Gujarat",
    latitude: 20.3667,
    longitude: 72.9167,
  },
  {
    id: "820",
    name: "Sanawad",
    state: "Madhya Pradesh",
    latitude: 22.1667,
    longitude: 75.8333,
  },
  {
    id: "821",
    name: "Warisaliganj",
    state: "Bihar",
    latitude: 25.4167,
    longitude: 85.4167,
  },
  {
    id: "822",
    name: "Revelganj",
    state: "Bihar",
    latitude: 25.4167,
    longitude: 85.4167,
  },
  {
    id: "823",
    name: "Sabalgarh",
    state: "Madhya Pradesh",
    latitude: 26.4167,
    longitude: 78.4167,
  },
  {
    id: "824",
    name: "Tuljapur",
    state: "Maharashtra",
    latitude: 18.4167,
    longitude: 76.416,
  },
  { id: "825", name: "Simdega", state: "Jharkhand", lat: 22.614, lng: 84.663 },
  { id: "826", name: "Musabani", state: "Jharkhand", lat: 22.616, lng: 86.385 },
  { id: "827", name: "Kodungallur", state: "Kerala", lat: 10.3, lng: 76.2 },
  { id: "828", name: "Phulabani", state: "Odisha", lat: 20.46, lng: 84.0 },
  { id: "829", name: "Umreth", state: "Gujarat", lat: 22.65, lng: 73.1 },
  {
    id: "830",
    name: "Narsipatnam",
    state: "Andhra Pradesh",
    lat: 17.366,
    lng: 82.7,
  },
  {
    id: "831",
    name: "Nautanwa",
    state: "Uttar Pradesh",
    lat: 27.0,
    lng: 83.75,
  },
  { id: "832", name: "Rajgir", state: "Bihar", lat: 25.0, lng: 85.417 },
  { id: "833", name: "Yellandu", state: "Telangana", lat: 17.966, lng: 80.0 },
  {
    id: "834",
    name: "Sathyamangalam",
    state: "Tamil Nadu",
    lat: 11.616,
    lng: 77.283,
  },
  { id: "835", name: "Pilibanga", state: "Rajasthan", lat: 29.25, lng: 74.1 },
  { id: "836", name: "Morshi", state: "Maharashtra", lat: 21.467, lng: 77.767 },
  { id: "837", name: "Pehowa", state: "Haryana", lat: 29.95, lng: 76.567 },
  { id: "838", name: "Sonepur", state: "Bihar", lat: 25.783, lng: 85.217 },
  { id: "839", name: "Pappinisseri", state: "Kerala", lat: 11.9, lng: 75.467 },
  {
    id: "840",
    name: "Zamania",
    state: "Uttar Pradesh",
    lat: 25.383,
    lng: 83.533,
  },
  { id: "841", name: "Mihijam", state: "Jharkhand", lat: 23.65, lng: 86.75 },
  { id: "842", name: "Purna", state: "Maharashtra", lat: 19.283, lng: 77.517 },
  {
    id: "843",
    name: "Puliyankudi",
    state: "Tamil Nadu",
    lat: 9.25,
    lng: 77.55,
  },
  {
    id: "844",
    name: "Shikarpur, Bulandshahr",
    state: "Uttar Pradesh",
    lat: 28.417,
    lng: 77.717,
  },
  {
    id: "845",
    name: "Umaria",
    state: "Madhya Pradesh",
    lat: 23.566,
    lng: 80.75,
  },
  {
    id: "846",
    name: "Porsa",
    state: "Madhya Pradesh",
    lat: 25.417,
    lng: 78.383,
  },
  {
    id: "847",
    name: "Naugawan Sadat",
    state: "Uttar Pradesh",
    lat: 28.4,
    lng: 78.3,
  },
  {
    id: "848",
    name: "Fatehpur Sikri",
    state: "Uttar Pradesh",
    lat: 27.1,
    lng: 77.666,
  },
  { id: "849", name: "Manuguru", state: "Telangana", lat: 17.55, lng: 80.567 },
  { id: "850", name: "Udaipur", state: "Tripura", lat: 23.467, lng: 91.75 },
  {
    id: "851",
    name: "Pipar City",
    state: "Rajasthan",
    lat: 26.385599,
    lng: 73.537804,
  },
  {
    id: "852",
    name: "Pattamundai",
    state: "Odisha",
    lat: 20.4528,
    lng: 86.6027,
  },
  {
    id: "853",
    name: "Nanjikottai",
    state: "Tamil Nadu",
    lat: 10.9645,
    lng: 79.1432,
  },
  {
    id: "854",
    name: "Taranagar",
    state: "Rajasthan",
    lat: 28.671349,
    lng: 75.034264,
  },
  {
    id: "855",
    name: "Yerraguntla",
    state: "Andhra Pradesh",
    lat: 14.9175,
    lng: 78.2808,
  },
  {
    id: "856",
    name: "Satana",
    state: "Maharashtra",
    lat: 20.2719,
    lng: 74.1667,
  },
  {
    id: "857",
    name: "Sherghati",
    state: "Bihar",
    lat: 24.5676844,
    lng: 84.8013339,
  },
  {
    id: "858",
    name: "Sankeshwara",
    state: "Karnataka",
    lat: 15.8833,
    lng: 74.6167,
  },
  {
    id: "859",
    name: "Madikeri",
    state: "Karnataka",
    lat: 12.427189,
    lng: 75.747643,
  },
  {
    id: "860",
    name: "Thuraiyur",
    state: "Tamil Nadu",
    lat: 11.141455,
    lng: 78.594475,
  },
  {
    id: "861",
    name: "Sanand",
    state: "Gujarat",
    lat: 22.991289,
    lng: 72.375511,
  },
  { id: "862", name: "Rajula", state: "Gujarat", lat: 21.5167, lng: 71.5333 },
  {
    id: "863",
    name: "Kyathampalle",
    state: "Telangana",
    lat: 17.4167,
    lng: 78.5667,
  },
  {
    id: "864",
    name: "Shahabad, Rampur",
    state: "Uttar Pradesh",
    lat: 28.8175,
    lng: 79.0156,
  },
  {
    id: "865",
    name: "Tilda Newra",
    state: "Chhattisgarh",
    lat: 21.2833,
    lng: 81.6833,
  },
  {
    id: "866",
    name: "Narsinghgarh",
    state: "Madhya Pradesh",
    lat: 23.5167,
    lng: 76.95,
  },
  {
    id: "867",
    name: "Chittur-Thathamangalam",
    state: "Kerala",
    lat: 10.9667,
    lng: 76.6333,
  },
  {
    id: "868",
    name: "Malaj Khand",
    state: "Madhya Pradesh",
    lat: 22.0,
    lng: 78.0,
  },
  {
    id: "869",
    name: "Sarangpur",
    state: "Madhya Pradesh",
    lat: 23.5,
    lng: 76.5,
  },
  {
    id: "870",
    name: "Robertsganj",
    state: "Uttar Pradesh",
    lat: 25.3,
    lng: 83.1,
  },
  {
    id: "871",
    name: "Sirkali",
    state: "Tamil Nadu",
    lat: 11.1167,
    lng: 79.8667,
  },
  { id: "872", name: "Radhanpur", state: "Gujarat", lat: 23.8, lng: 71.6167 },
  {
    id: "873",
    name: "Tiruchendur",
    state: "Tamil Nadu",
    lat: 8.4819,
    lng: 78.1333,
  },
  {
    id: "874",
    name: "Utraula",
    state: "Uttar Pradesh",
    lat: 27.5667,
    lng: 81.6167,
  },
  { id: "875", name: "Patratu", state: "Jharkhand", lat: 23.7, lng: 85.0 },
  {
    id: "876",
    name: "Vijainagar, Ajmer",
    state: "Rajasthan",
    lat: 26.5,
    lng: 74.5,
  },
  { id: "877", name: "Periyasemur", state: "Tamil Nadu", lat: 11.0, lng: 77.0 },
  { id: "878", name: "Pathri", state: "Maharashtra", lat: 19.0, lng: 75.0 },
  { id: "879", name: "Sadabad", state: "Uttar Pradesh", lat: 27.25, lng: 78.0 },
  { id: "880", name: "Talikota", state: "Karnataka", lat: 16.5, lng: 75.0 },
  { id: "881", name: "Sinnar", state: "Maharashtra", lat: 19.5, lng: 74.0 },
  { id: "882", name: "Mungeli", state: "Chhattisgarh", lat: 22.0, lng: 81.0 },
  { id: "883", name: "Sedam", state: "Karnataka", lat: 17.5, lng: 77.0 },
  { id: "884", name: "Shikaripur", state: "Karnataka", lat: 14.5, lng: 75.0 },
  { id: "885", name: "Sumerpur", state: "Rajasthan", lat: 26.0, lng: 75.0 },
  { id: "886", name: "Sattur", state: "Tamil Nadu", lat: 9.5, lng: 77.0 },
  {
    id: "887",
    name: "Sugauli",
    state: "Bihar",
    lat: 26.764004,
    lng: 84.738235,
  },
  { id: "888", name: "Lumding", state: "Assam", lat: 25.4914, lng: 93.2786 },
  {
    id: "889",
    name: "Vandavasi",
    state: "Tamil Nadu",
    lat: 12.502883,
    lng: 79.602478,
  },
  { id: "890", name: "Titlagarh", state: "Odisha", lat: 19.9383, lng: 83.1704 },
  {
    id: "891",
    name: "Uchgaon",
    state: "Maharashtra",
    lat: 16.7074,
    lng: 74.1392,
  },
  {
    id: "892",
    name: "Mokokchung",
    state: "Nagaland",
    lat: 26.32,
    lng: 94.5333,
  },
  {
    id: "893",
    name: "Paschim Punropara",
    state: "West Bengal",
    lat: 22.9667,
    lng: 88.5333,
  },
  {
    id: "894",
    name: "Sagwara",
    state: "Rajasthan",
    lat: 23.68,
    lng: 74.019997,
  },
  {
    id: "895",
    name: "Ramganj Mandi",
    state: "Rajasthan",
    lat: 24.8694,
    lng: 75.5142,
  },
  { id: "896", name: "Tarakeswar", state: "West Bengal", lat: 22.9, lng: 88.3 },
  {
    id: "897",
    name: "Mahalingapura",
    state: "Karnataka",
    lat: 14.47,
    lng: 75.67,
  },
  {
    id: "898",
    name: "Dharmanagar",
    state: "Tripura",
    lat: 24.0667,
    lng: 92.0167,
  },
  { id: "899", name: "Mahemdabad", state: "Gujarat", lat: 22.67, lng: 73.01 },
  {
    id: "900",
    name: "Manendragarh",
    state: "Chhattisgarh",
    lat: 23.21389,
    lng: 82.201279,
  },
  { id: "901", name: "Uran", state: "Maharashtra", lat: 18.8333, lng: 72.9833 },
  {
    id: "902",
    name: "Tharamangalam",
    state: "Tamil Nadu",
    lat: 11.55,
    lng: 77.75,
  },
  {
    id: "903",
    name: "Tirukkoyilur",
    state: "Tamil Nadu",
    lat: 11.8833,
    lng: 79.15,
  },
  { id: "904", name: "Pen", state: "Maharashtra", lat: 18.9833, lng: 73.1667 },
  { id: "905", name: "Makhdumpur", state: "Bihar", lat: 25.1667, lng: 85.5 },
  { id: "906", name: "Maner", state: "Bihar", lat: 25.6, lng: 84.9 },
  {
    id: "907",
    name: "Oddanchatram",
    state: "Tamil Nadu",
    lat: 10.4,
    lng: 77.5667,
  },
  { id: "908", name: "Palladam", state: "Tamil Nadu", lat: 10.6, lng: 77.0167 },
  { id: "909", name: "Mundi", state: "Madhya Pradesh", lat: 22.6, lng: 76.25 },
  { id: "910", name: "Nabarangapur", state: "Odisha", lat: 19.27, lng: 82.55 },
  {
    id: "911",
    name: "Mudalagi",
    state: "Karnataka",
    lat: 16.4167,
    lng: 75.4167,
  },
  { id: "912", name: "Samalkha", state: "Haryana", lat: 29.0833, lng: 77.0167 },
  {
    id: "913",
    name: "Nepanagar",
    state: "Madhya Pradesh",
    lat: 21.5667,
    lng: 76.75,
  },
  { id: "914", name: "Karjat", state: "Maharashtra", lat: 18.75, lng: 73.4167 },
  { id: "915", name: "Ranavav", state: "Gujarat", lat: 21.75, lng: 70.75 },
  {
    id: "916",
    name: "Pedana",
    state: "Andhra Pradesh",
    lat: 16.4667,
    lng: 81.1167,
  },
  { id: "917", name: "Pinjore", state: "Haryana", lat: 30.6, lng: 76.9167 },
  { id: "918", name: "Lakheri", state: "Rajasthan", lat: 25.5667, lng: 76.1 },
  { id: "919", name: "Pasan", state: "Madhya Pradesh", lat: 22.5, lng: 81.75 },
  { id: "920", name: "Puttur", state: "Andhra Pradesh", lat: 13.9, lng: 79.6 },
  {
    id: "921",
    name: "Vadakkuvalliyur",
    state: "Tamil Nadu",
    lat: 8.5191,
    lng: 77.627,
  },
  {
    id: "922",
    name: "Tirukalukundram",
    state: "Tamil Nadu",
    lat: 12.6208,
    lng: 79.8383,
  },
  {
    id: "923",
    name: "Mahidpur",
    state: "Madhya Pradesh",
    lat: 23.687,
    lng: 75.582,
  },
  {
    id: "924",
    name: "Mussoorie",
    state: "Uttarakhand",
    lat: 30.459,
    lng: 78.0669,
  },
  {
    id: "925",
    name: "Muvattupuzha",
    state: "Kerala",
    lat: 9.9161,
    lng: 76.5511,
  },
  {
    id: "926",
    name: "Rasra",
    state: "Uttar Pradesh",
    lat: 26.2623,
    lng: 83.5029,
  },
  {
    id: "927",
    name: "Udaipurwati",
    state: "Rajasthan",
    lat: 27.995,
    lng: 75.191,
  },
  {
    id: "928",
    name: "Manwath",
    state: "Maharashtra",
    lat: 18.7731,
    lng: 76.4312,
  },
  {
    id: "929",
    name: "Adoor",
    state: "Kerala",
    lat: 9.15,
    lng: 76.75,
  },
  {
    id: "930",
    name: "Uthamapalayam",
    state: "Tamil Nadu",
    lat: 9.5919,
    lng: 77.4636,
  },
  {
    id: "931",
    name: "Partur",
    state: "Maharashtra",
    lat: 19.6494,
    lng: 76.0683,
  },
  {
    id: "932",
    name: "Nahan",
    state: "Himachal Pradesh",
    lat: 30.5601,
    lng: 77.313,
  },
  {
    id: "933",
    name: "Ladwa",
    state: "Haryana",
    lat: 29.8785,
    lng: 76.2804,
  },
  {
    id: "934",
    name: "Mankachar",
    state: "Assam",
    lat: 26.15,
    lng: 90.1178,
  },
  {
    id: "935",
    name: "Nongstoin",
    state: "Meghalaya",
    lat: 25.5572,
    lng: 91.3592,
  },
  {
    id: "936",
    name: "Losal",
    state: "Rajasthan",
    lat: 27.2919,
    lng: 75.0406,
  },
  {
    id: "937",
    name: "Sri Madhopur",
    state: "Rajasthan",
    lat: 27.6824,
    lng: 75.1308,
  },
  {
    id: "938",
    name: "Ramngarh",
    state: "Rajasthan",
    lat: 27.3095,
    lng: 75.0446,
  },
  {
    id: "939",
    name: "Mavelikkara",
    state: "Kerala",
    lat: 9.2709,
    lng: 76.5766,
  },
  {
    id: "940",
    name: "Rawatsar",
    state: "Rajasthan",
    lat: 29.2683,
    lng: 74.4885,
  },
  {
    id: "941",
    name: "Rajakhera",
    state: "Rajasthan",
    lat: 27.7732,
    lng: 78.2167,
  },
  {
    id: "942",
    name: "Lar",
    state: "Uttar Pradesh",
    lat: 27.05,
    lng: 81.4,
  },
  {
    id: "943",
    name: "Lal Gopalganj Nindaura",
    state: "Uttar Pradesh",
    lat: 25.5226,
    lng: 83.6285,
  },
  {
    id: "944",
    name: "Muddebihal",
    state: "Karnataka",
    lat: 16.426,
    lng: 76.184,
  },
  {
    id: "945",
    name: "Sirsaganj",
    state: "Uttar Pradesh",
    lat: 27.0122,
    lng: 78.5433,
  },
  {
    id: "946",
    name: "Shahpura",
    state: "Rajasthan",
    lat: 26.698,
    lng: 75.0171,
  },
  {
    id: "947",
    name: "Surandai",
    state: "Tamil Nadu",
    lat: 8.9527,
    lng: 77.4053,
  },
  {
    id: "948",
    name: "Sangole",
    state: "Maharashtra",
    lat: 17.1236,
    lng: 75.021,
  },
  {
    id: "949",
    name: "Pavagada",
    state: "Karnataka",
    lat: 14.7493,
    lng: 77.0556,
  },
  {
    id: "950",
    name: "Tharad",
    state: "Gujarat",
    lat: 24.25,
    lng: 71.6,
  },
  {
    id: "951",
    name: "Mansa",
    state: "Gujarat",
    lat: 22.3133,
    lng: 71.6694,
  },
  {
    id: "952",
    name: "Umbergaon",
    state: "Gujarat",
    lat: 20.4333,
    lng: 72.95,
  },
  {
    id: "953",
    name: "Mavoor",
    state: "Kerala",
    lat: 11.28,
    lng: 75.88,
  },
  {
    id: "954",
    name: "Nalbari",
    state: "Assam",
    lat: 26.4357,
    lng: 91.4378,
  },
  {
    id: "955",
    name: "Talaja",
    state: "Gujarat",
    lat: 21.4124,
    lng: 71.6666,
  },
  {
    id: "956",
    name: "Malur",
    state: "Karnataka",
    lat: 12.979,
    lng: 77.7905,
  },
  {
    id: "957",
    name: "Mangrulpir",
    state: "Maharashtra",
    lat: 20.3894,
    lng: 77.913,
  },
  {
    id: "958",
    name: "Soro",
    state: "Odisha",
    lat: 21.05,
    lng: 86.7,
  },
  {
    id: "959",
    name: "Shahpura",
    state: "Rajasthan",
    lat: 26.826,
    lng: 74.898,
  },
  {
    id: "960",
    name: "Vadnagar",
    state: "Gujarat",
    lat: 23.8749,
    lng: 72.6248,
  },
  {
    id: "961",
    name: "Raisinghnagar",
    state: "Rajasthan",
    lat: 29.0441,
    lng: 73.3749,
  },
  {
    id: "962",
    name: "Sindhagi",
    state: "Karnataka",
    lat: 16.295,
    lng: 76.1427,
  },
  {
    id: "963",
    name: "Sanduru",
    state: "Karnataka",
    lat: 15.37,
    lng: 76.5345,
  },
  {
    id: "964",
    name: "Sohna",
    state: "Haryana",
    lat: 28.2634,
    lng: 77.0785,
  },
  {
    id: "965",
    name: "Manavadar",
    state: "Gujarat",
    lat: 21.4642,
    lng: 70.2022,
  },
  {
    id: "966",
    name: "Pihani",
    state: "Uttar Pradesh",
    lat: 27.3583,
    lng: 79.2125,
  },
  {
    id: "967",
    name: "Safidon",
    state: "Haryana",
    lat: 29.6673,
    lng: 76.7469,
  },
  {
    id: "968",
    name: "Risod",
    state: "Maharashtra",
    lat: 20.1145,
    lng: 77.155,
  },
  {
    id: "969",
    name: "Rosera",
    state: "Bihar",
    lat: 26.2434,
    lng: 86.7711,
  },
  {
    id: "970",
    name: "Sankari",
    state: "Tamil Nadu",
    lat: 11.5172,
    lng: 77.7081,
  },
  {
    id: "971",
    name: "Malpura",
    state: "Rajasthan",
    lat: 26.7397,
    lng: 75.1961,
  },
  {
    id: "972",
    name: "Sonamukhi",
    state: "West Bengal",
    lat: 23.35,
    lng: 87.55,
  },
  {
    id: "973",
    name: "Shamsabad, Agra",
    state: "Uttar Pradesh",
    lat: 27.0427,
    lng: 78.0096,
  },
  {
    id: "974",
    name: "Nokha",
    state: "Bihar",
    lat: 25.45,
    lng: 85.5833,
  },
  {
    id: "975",
    name: "PandUrban Agglomeration",
    state: "West Bengal",
    lat: 22.57,
    lng: 88.36,
  },
  {
    id: "976",
    name: "Mainaguri",
    state: "West Bengal",
    lat: 26.45,
    lng: 88.69,
  },
  {
    id: "977",
    name: "Afzalpur",
    state: "Karnataka",
    lat: 17.1458,
    lng: 76.0135,
  },
  {
    id: "978",
    name: "Shirur",
    state: "Maharashtra",
    lat: 18.7667,
    lng: 74.4333,
  },
  {
    id: "979",
    name: "Salaya",
    state: "Gujarat",
    lat: 21.6865,
    lng: 69.7299,
  },
  {
    id: "980",
    name: "Shenkottai",
    state: "Tamil Nadu",
    lat: 9.1056,
    lng: 77.1786,
  },
  {
    id: "981",
    name: "Pratapgarh",
    state: "Tripura",
    lat: 23.8333,
    lng: 91.2833,
  },
  {
    id: "982",
    name: "Vadipatti",
    state: "Tamil Nadu",
    lat: 9.9309,
    lng: 77.9134,
  },
  {
    id: "983",
    name: "Nagarkurnool",
    state: "Telangana",
    lat: 16.4858,
    lng: 78.0967,
  },
  {
    id: "984",
    name: "Savner",
    state: "Maharashtra",
    lat: 21.08,
    lng: 79.15,
  },
  {
    id: "985",
    name: "Sasvad",
    state: "Maharashtra",
    lat: 18.2933,
    lng: 74.0527,
  },
  {
    id: "986",
    name: "Rudrapur",
    state: "Uttar Pradesh",
    lat: 28.98,
    lng: 79.4,
  },
  {
    id: "987",
    name: "Soron",
    state: "Uttar Pradesh",
    lat: 27.3387,
    lng: 79.0171,
  },
  {
    id: "988",
    name: "Sholingur",
    state: "Tamil Nadu",
    lat: 12.745,
    lng: 78.5677,
  },
  {
    id: "989",
    name: "Pandharkaoda",
    state: "Maharashtra",
    lat: 20.3833,
    lng: 77.8667,
  },
  {
    id: "990",
    name: "Perumbavoor",
    state: "Kerala",
    lat: 10.1207,
    lng: 76.5589,
  },
  {
    id: "991",
    name: "Maddur",
    state: "Karnataka",
    lat: 12.5903,
    lng: 77.143,
  },
  {
    id: "992",
    name: "Nadbai",
    state: "Rajasthan",
    lat: 26.7726,
    lng: 77.716,
  },
  {
    id: "993",
    name: "Talode",
    state: "Maharashtra",
    lat: 21.0833,
    lng: 74.4333,
  },
  {
    id: "994",
    name: "Shrigonda",
    state: "Maharashtra",
    lat: 18.3673,
    lng: 74.6416,
  },
  {
    id: "995",
    name: "Madhugiri",
    state: "Karnataka",
    lat: 13.4944,
    lng: 77.01,
  },
  {
    id: "996",
    name: "Tekkalakote",
    state: "Karnataka",
    lat: 15.59,
    lng: 76.36,
  },
  {
    id: "997",
    name: "Seoni-Malwa",
    state: "Madhya Pradesh",
    lat: 22.8833,
    lng: 77.8,
  },
  {
    id: "998",
    name: "Shirdi",
    state: "Maharashtra",
    lat: 19.7661,
    lng: 74.4774,
  },
  {
    id: "999",
    name: "SUrban Agglomerationr",
    state: "Uttar Pradesh",
    lat: 26.76,
    lng: 82.13,
  },
  {
    id: "1000",
    name: "Terdal",
    state: "Karnataka",
    lat: 16.345,
    lng: 75.276,
  },
  {
    id: "1001",
    name: "Raver",
    state: "Maharashtra",
    lat: 21.25,
    lng: 75.6667,
  },
  {
    id: "1002",
    name: "Tirupathur",
    state: "Tamil Nadu",
    lat: 12.5273,
    lng: 78.5741,
  },
  {
    id: "1003",
    name: "Taraori",
    state: "Haryana",
    lat: 29.6785,
    lng: 76.945,
  },
  {
    id: "1004",
    name: "Mukhed",
    state: "Maharashtra",
    lat: 19.596,
    lng: 77.316,
  },
  {
    id: "1005",
    name: "Manachanallur",
    state: "Tamil Nadu",
    lat: 10.95,
    lng: 78.5167,
  },
  {
    id: "1006",
    name: "Rehli",
    state: "Madhya Pradesh",
    lat: 24.017,
    lng: 79.297,
  },
  {
    id: "1007",
    name: "Sanchore",
    state: "Rajasthan",
    lat: 24.74,
    lng: 72.75,
  },
  {
    id: "1008",
    name: "Rajura",
    state: "Maharashtra",
    lat: 19.7723,
    lng: 79.3773,
  },
  {
    id: "1009",
    name: "Piro",
    state: "Bihar",
    lat: 25.0833,
    lng: 84.5,
  },
  {
    id: "1010",
    name: "Mudabidri",
    state: "Karnataka",
    lat: 13.1353,
    lng: 74.98,
  },
  {
    id: "1011",
    name: "Vadgaon Kasba",
    state: "Maharashtra",
    lat: 18.2993,
    lng: 73.8685,
  },
  {
    id: "1012",
    name: "Nagar",
    state: "Rajasthan",
    lat: 26.431,
    lng: 75.056,
  },
  {
    id: "1013",
    name: "Vijapur",
    state: "Gujarat",
    lat: 23.4605,
    lng: 72.7607,
  },
  {
    id: "1014",
    name: "Viswanatham",
    state: "Tamil Nadu",
    lat: 9.5841,
    lng: 78.28,
  },
  {
    id: "1015",
    name: "Polur",
    state: "Tamil Nadu",
    lat: 12.4574,
    lng: 79.1471,
  },
  {
    id: "1016",
    name: "Panagudi",
    state: "Tamil Nadu",
    lat: 8.4075,
    lng: 77.4107,
  },
  {
    id: "1017",
    name: "Manawar",
    state: "Madhya Pradesh",
    lat: 22.0824,
    lng: 75.2649,
  },
  {
    id: "1018",
    name: "Tehri",
    state: "Uttarakhand",
    lat: 30.296,
    lng: 78.416,
  },
  {
    id: "1019",
    name: "Samdhan",
    state: "Uttar Pradesh",
    lat: 27.15,
    lng: 80.6667,
  },
  {
    id: "1020",
    name: "Pardi",
    state: "Gujarat",
    lat: 20.3926,
    lng: 72.9323,
  },
  {
    id: "1021",
    name: "Rahatgarh",
    state: "Madhya Pradesh",
    lat: 23.6754,
    lng: 78.8302,
  },
  {
    id: "1022",
    name: "Panagar",
    state: "Madhya Pradesh",
    lat: 23.6094,
    lng: 80.1942,
  },
  {
    id: "1023",
    name: "Uthiramerur",
    state: "Tamil Nadu",
    lat: 12.47,
    lng: 79.74,
  },
  {
    id: "1024",
    name: "Tirora",
    state: "Maharashtra",
    lat: 21.29,
    lng: 79.94,
  },
  {
    id: "1025",
    name: "Rangia",
    state: "Assam",
    lat: 26.35,
    lng: 91.65,
  },
  {
    id: "1026",
    name: "Sahjanwa",
    state: "Uttar Pradesh",
    lat: 26.8093,
    lng: 83.0534,
  },
  {
    id: "1027",
    name: "Wara Seoni",
    state: "Madhya Pradesh",
    lat: 22.0667,
    lng: 79.7,
  },
  {
    id: "1028",
    name: "Magadi",
    state: "Karnataka",
    lat: 12.99,
    lng: 77.21,
  },
  {
    id: "1029",
    name: "Rajgarh (Alwar)",
    state: "Rajasthan",
    lat: 27.2833,
    lng: 76.6167,
  },
  {
    id: "1030",
    name: "Rafiganj",
    state: "Bihar",
    lat: 24.86,
    lng: 84.75,
  },
  {
    id: "1031",
    name: "Tarana",
    state: "Madhya Pradesh",
    lat: 23.3757,
    lng: 76.1419,
  },
  {
    id: "1032",
    name: "Rampur Maniharan",
    state: "Uttar Pradesh",
    lat: 29.08,
    lng: 77.33,
  },
  {
    id: "1033",
    name: "Sheoganj",
    state: "Rajasthan",
    lat: 25.0667,
    lng: 74.5667,
  },
  {
    id: "1034",
    name: "Raikot",
    state: "Punjab",
    lat: 30.4886,
    lng: 75.3408,
  },
  {
    id: "1035",
    name: "Pauri",
    state: "Uttarakhand",
    lat: 29.7903,
    lng: 78.7807,
  },
  {
    id: "1036",
    name: "Sumerpur",
    state: "Uttar Pradesh",
    lat: 26.6287,
    lng: 81.2545,
  },
  {
    id: "1037",
    name: "Navalgund",
    state: "Karnataka",
    lat: 15.6,
    lng: 75.6,
  },
  {
    id: "1038",
    name: "Shahganj",
    state: "Uttar Pradesh",
    lat: 26.0915,
    lng: 82.3074,
  },
  {
    id: "1039",
    name: "Marhaura",
    state: "Bihar",
    lat: 25.91,
    lng: 85.75,
  },
  {
    id: "1040",
    name: "Tulsipur",
    state: "Uttar Pradesh",
    lat: 27.2167,
    lng: 82.35,
  },
  {
    id: "1041",
    name: "Sadri",
    state: "Rajasthan",
    lat: 25.14,
    lng: 73.47,
  },
  {
    id: "1042",
    name: "Thiruthuraipoondi",
    state: "Tamil Nadu",
    lat: 10.66,
    lng: 79.62,
  },
  {
    id: "1043",
    name: "Shiggaon",
    state: "Karnataka",
    lat: 14.25,
    lng: 75.4333,
  },
  {
    id: "1044",
    name: "Pallapatti",
    state: "Tamil Nadu",
    lat: 11.25,
    lng: 78.1,
  },
  {
    id: "1045",
    name: "Mahendragarh",
    state: "Haryana",
    lat: 28.29,
    lng: 76.13,
  },
  {
    id: "1046",
    name: "Sausar",
    state: "Madhya Pradesh",
    lat: 21.4333,
    lng: 79.9167,
  },
  {
    id: "1047",
    name: "Ponneri",
    state: "Tamil Nadu",
    lat: 13.28,
    lng: 80.24,
  },
  {
    id: "1048",
    name: "Mahad",
    state: "Maharashtra",
    lat: 18.08,
    lng: 73.12,
  },
  {
    id: "1049",
    name: "Lohardaga",
    state: "Jharkhand",
    lat: 23.43,
    lng: 84.68,
  },
  {
    id: "1050",
    name: "Tirwaganj",
    state: "Uttar Pradesh",
    lat: 27.21,
    lng: 79.94,
  },
  {
    id: "1051",
    name: "Margherita",
    state: "Assam",
    lat: 27.31,
    lng: 95.68,
  },
  {
    id: "1052",
    name: "Sundarnagar",
    state: "Himachal Pradesh",
    lat: 31.52,
    lng: 76.85,
  },
  {
    id: "1053",
    name: "Rajgarh",
    state: "Madhya Pradesh",
    lat: 24.25,
    lng: 77.82,
  },
  {
    id: "1054",
    name: "Mangaldoi",
    state: "Assam",
    lat: 26.43,
    lng: 92.0,
  },
  {
    id: "1055",
    name: "Renigunta",
    state: "Andhra Pradesh",
    lat: 13.62,
    lng: 79.55,
  },
  {
    id: "1056",
    name: "Longowal",
    state: "Punjab",
    lat: 30.73,
    lng: 75.74,
  },
  {
    id: "1057",
    name: "Ratia",
    state: "Haryana",
    lat: 29.47,
    lng: 75.96,
  },
  {
    id: "1058",
    name: "Lalgudi",
    state: "Tamil Nadu",
    lat: 11.06,
    lng: 78.75,
  },
  {
    id: "1059",
    name: "Shrirangapattana",
    state: "Karnataka",
    lat: 12.4196,
    lng: 76.6907,
  },
  {
    id: "1060",
    name: "Niwari",
    state: "Madhya Pradesh",
    lat: 24.77,
    lng: 79.87,
  },
  {
    id: "1061",
    name: "Natham",
    state: "Tamil Nadu",
    lat: 10.04,
    lng: 78.49,
  },
  {
    id: "1062",
    name: "Unnamalaikadai",
    state: "Tamil Nadu",
    lat: 8.1567,
    lng: 77.4167,
  },
  {
    id: "1063",
    name: "PurqUrban Agglomerationzi",
    state: "Uttar Pradesh",
    lat: 25.4333,
    lng: 81.8495,
  },
  {
    id: "1064",
    name: "Shamsabad, Farrukhabad",
    state: "Uttar Pradesh",
    lat: 27.3896,
    lng: 79.5683,
  },
  {
    id: "1065",
    name: "Mirganj",
    state: "Bihar",
    lat: 26.6,
    lng: 84.7,
  },
  {
    id: "1066",
    name: "Todaraisingh",
    state: "Rajasthan",
    lat: 25.2,
    lng: 75.0333,
  },
  {
    id: "1067",
    name: "Warhapur",
    state: "Uttar Pradesh",
    lat: 26.8333,
    lng: 82.8167,
  },
  {
    id: "1068",
    name: "Rajam",
    state: "Andhra Pradesh",
    lat: 18.4,
    lng: 83.35,
  },
  {
    id: "1069",
    name: "Urmar Tanda",
    state: "Punjab",
    lat: 31.0539,
    lng: 75.3472,
  },
  {
    id: "1070",
    name: "Lonar",
    state: "Maharashtra",
    lat: 19.975,
    lng: 76.5167,
  },
  {
    id: "1071",
    name: "Powayan",
    state: "Uttar Pradesh",
    lat: 28.26,
    lng: 79.17,
  },
  {
    id: "1072",
    name: "P.N.Patti",
    state: "Tamil Nadu",
    lat: 11.59,
    lng: 78.09,
  },
  {
    id: "1073",
    name: "Palampur",
    state: "Himachal Pradesh",
    lat: 32.1,
    lng: 76.5333,
  },
  {
    id: "1074",
    name: "Srisailam Project (Right Flank Colony) Township",
    state: "Andhra Pradesh",
    lat: 16.0833,
    lng: 78.8667,
  },
  {
    id: "1075",
    name: "Sindagi",
    state: "Karnataka",
    lat: 16.6,
    lng: 76.8,
  },
  {
    id: "1076",
    name: "Sandi",
    state: "Uttar Pradesh",
    lat: 27.1676,
    lng: 79.5771,
  },
  {
    id: "1077",
    name: "Vaikom",
    state: "Kerala",
    lat: 9.73,
    lng: 76.35,
  },
  {
    id: "1078",
    name: "Malda",
    state: "West Bengal",
    lat: 25.0,
    lng: 88.15,
  },
  {
    id: "1079",
    name: "Tharangambadi",
    state: "Tamil Nadu",
    lat: 11.02,
    lng: 79.85,
  },
  {
    id: "1080",
    name: "Sakaleshapura",
    state: "Karnataka",
    lat: 13.37,
    lng: 75.43,
  },
  {
    id: "1081",
    name: "Lalganj",
    state: "Bihar",
    lat: 25.4176,
    lng: 84.7336,
  },
  {
    id: "1082",
    name: "Malkangiri",
    state: "Odisha",
    lat: 18.35,
    lng: 82.65,
  },
  {
    id: "1083",
    name: "Rapar",
    state: "Gujarat",
    lat: 23.83,
    lng: 69.8,
  },
  {
    id: "1084",
    name: "Mauganj",
    state: "Madhya Pradesh",
    lat: 24.7,
    lng: 81.6833,
  },
  {
    id: "1085",
    name: "Todabhim",
    state: "Rajasthan",
    lat: 26.1833,
    lng: 76.5167,
  },
  {
    id: "1086",
    name: "Srinivaspur",
    state: "Karnataka",
    lat: 13.35,
    lng: 78.12,
  },
  {
    id: "1087",
    name: "Murliganj",
    state: "Bihar",
    lat: 26.0,
    lng: 87.45,
  },
  {
    id: "1088",
    name: "Reengus",
    state: "Rajasthan",
    lat: 27.0,
    lng: 75.6,
  },
  {
    id: "1089",
    name: "Sawantwadi",
    state: "Maharashtra",
    lat: 15.9,
    lng: 73.8,
  },
  {
    id: "1090",
    name: "Tittakudi",
    state: "Tamil Nadu",
    lat: 11.46,
    lng: 79.54,
  },
  {
    id: "1091",
    name: "Lilong",
    state: "Manipur",
    lat: 24.6333,
    lng: 93.95,
  },
  {
    id: "1092",
    name: "Rajaldesar",
    state: "Rajasthan",
    lat: 28.3333,
    lng: 74.4167,
  },
  {
    id: "1093",
    name: "Pathardi",
    state: "Maharashtra",
    lat: 19.05,
    lng: 75.15,
  },
  {
    id: "1094",
    name: "Achhnera",
    state: "Uttar Pradesh",
    lat: 27.22,
    lng: 77.87,
  },
  {
    id: "1095",
    name: "Pacode",
    state: "Tamil Nadu",
    lat: 8.32,
    lng: 77.43,
  },
  {
    id: "1096",
    name: "Naraura",
    state: "Uttar Pradesh",
    lat: 28.31,
    lng: 78.45,
  },
  {
    id: "1097",
    name: "Nakur",
    state: "Uttar Pradesh",
    lat: 29.24,
    lng: 77.21,
  },
  {
    id: "1098",
    name: "Palai",
    state: "Kerala",
    lat: 9.71,
    lng: 76.7,
  },
  {
    id: "1099",
    name: "Morinda, India",
    state: "Punjab",
    lat: 30.81,
    lng: 76.46,
  },
  {
    id: "1100",
    name: "Manasa",
    state: "Madhya Pradesh",
    lat: 24.72,
    lng: 76.92,
  },
  {
    id: "1101",
    name: "Nainpur",
    state: "Madhya Pradesh",
    lat: 21.9333,
    lng: 79.8833,
  },
  {
    id: "1102",
    name: "Sahaspur",
    state: "Uttar Pradesh",
    lat: 29.07,
    lng: 78.43,
  },
  {
    id: "1103",
    name: "Pauni",
    state: "Maharashtra",
    lat: 20.85,
    lng: 79.76,
  },
  {
    id: "1104",
    name: "Prithvipur",
    state: "Madhya Pradesh",
    lat: 24.55,
    lng: 79.1,
  },
  {
    id: "1105",
    name: "Ramtek",
    state: "Maharashtra",
    lat: 21.32,
    lng: 79.3,
  },
  {
    id: "1106",
    name: "Silapathar",
    state: "Assam",
    lat: 27.2,
    lng: 95.28,
  },
  {
    id: "1107",
    name: "Songadh",
    state: "Gujarat",
    lat: 21.3667,
    lng: 73.1333,
  },
  {
    id: "1108",
    name: "Safipur",
    state: "Uttar Pradesh",
    lat: 26.875,
    lng: 80.34,
  },
  {
    id: "1109",
    name: "Sohagpur",
    state: "Madhya Pradesh",
    lat: 22.9833,
    lng: 79.3833,
  },
  {
    id: "1110",
    name: "Mul",
    state: "Maharashtra",
    lat: 20.42,
    lng: 78.02,
  },
  {
    id: "1110",
    name: "Mul",
    state: "Maharashtra",
    lat: 20.0177,
    lng: 77.9118,
  },
  {
    id: "1111",
    name: "Sadulshahar",
    state: "Rajasthan",
    lat: 29.315,
    lng: 74.6802,
  },
  {
    id: "1112",
    name: "Phillaur",
    state: "Punjab",
    lat: 31.0204,
    lng: 75.6858,
  },
  {
    id: "1113",
    name: "Sambhar",
    state: "Rajasthan",
    lat: 26.8955,
    lng: 75.1506,
  },
  {
    id: "1114",
    name: "Prantij",
    state: "Rajasthan",
    lat: 23.3403,
    lng: 72.9707,
  },
  {
    id: "1115",
    name: "Nagla",
    state: "Uttarakhand",
    lat: 29.9458,
    lng: 79.1336,
  },
  {
    id: "1116",
    name: "Pattran",
    state: "Punjab",
    lat: 31.6687,
    lng: 75.3293,
  },
  {
    id: "1117",
    name: "Mount Abu",
    state: "Rajasthan",
    lat: 24.593,
    lng: 72.7083,
  },
  {
    id: "1118",
    name: "Reoti",
    state: "Uttar Pradesh",
    lat: 26.7036,
    lng: 83.4936,
  },
  {
    id: "1119",
    name: "Tenu dam-cum-Kathhara",
    state: "Jharkhand",
    lat: 23.7822,
    lng: 85.9961,
  },
  {
    id: "1120",
    name: "Panchla",
    state: "West Bengal",
    lat: 22.4931,
    lng: 87.9856,
  },
  {
    id: "1121",
    name: "Sitarganj",
    state: "Uttarakhand",
    lat: 28.969,
    lng: 79.5372,
  },
  {
    id: "1122",
    name: "Pasighat",
    state: "Arunachal Pradesh",
    lat: 28.0667,
    lng: 95.3333,
  },
  {
    id: "1123",
    name: "Motipur",
    state: "Bihar",
    lat: 26.4203,
    lng: 84.3458,
  },
  {
    id: "1124",
    name: "O' Valley",
    state: "Tamil Nadu",
    lat: 11.3446,
    lng: 76.822,
  },
  {
    id: "1125",
    name: "Raghunathpur",
    state: "West Bengal",
    lat: 23.637,
    lng: 86.6695,
  },
  {
    id: "1126",
    name: "Suriyampalayam",
    state: "Tamil Nadu",
    lat: 11.35,
    lng: 77.01,
  },
  {
    id: "1127",
    name: "Qadian",
    state: "Punjab",
    lat: 31.8167,
    lng: 75.3667,
  },
  {
    id: "1128",
    name: "Rairangpur",
    state: "Odisha",
    lat: 22.2556,
    lng: 86.3725,
  },
  {
    id: "1129",
    name: "Silvassa",
    state: "Dadra and Nagar Haveli",
    lat: 20.2667,
    lng: 73.0167,
  },
  {
    id: "1130",
    name: "Nowrozabad (Khodargama)",
    state: "Madhya Pradesh",
    lat: 22.1586,
    lng: 81.825,
  },
  {
    id: "1131",
    name: "Mangrol",
    state: "Rajasthan",
    lat: 25.1833,
    lng: 73.3,
  },
  {
    id: "1132",
    name: "Soyagaon",
    state: "Maharashtra",
    lat: 20.1667,
    lng: 75.4667,
  },
  {
    id: "1133",
    name: "Sujanpur",
    state: "Punjab",
    lat: 31.6429,
    lng: 75.5747,
  },
  {
    id: "1134",
    name: "Manihari",
    state: "Bihar",
    lat: 25.76,
    lng: 87.36,
  },
  {
    id: "1135",
    name: "Sikanderpur",
    state: "Uttar Pradesh",
    lat: 26.85,
    lng: 83.0833,
  },
  {
    id: "1136",
    name: "Mangalvedhe",
    state: "Maharashtra",
    lat: 17.3667,
    lng: 75.3833,
  },
  {
    id: "1137",
    name: "Phulera",
    state: "Rajasthan",
    lat: 26.7654,
    lng: 75.1763,
  },
  {
    id: "1138",
    name: "Ron",
    state: "Karnataka",
    lat: 15.2667,
    lng: 75.9333,
  },
  {
    id: "1139",
    name: "Sholavandan",
    state: "Tamil Nadu",
    lat: 9.9735,
    lng: 77.8906,
  },
  {
    id: "1140",
    name: "Saidpur",
    state: "Uttar Pradesh",
    lat: 26.1469,
    lng: 82.8021,
  },
  {
    id: "1141",
    name: "Shamgarh",
    state: "Madhya Pradesh",
    lat: 24.7167,
    lng: 76.3833,
  },
  {
    id: "1142",
    name: "Thammampatti",
    state: "Tamil Nadu",
    lat: 11.48,
    lng: 78.45,
  },
  {
    id: "1143",
    name: "Maharajpur",
    state: "Madhya Pradesh",
    lat: 24.1934,
    lng: 78.1963,
  },
  {
    id: "1144",
    name: "Multai",
    state: "Madhya Pradesh",
    lat: 21.903,
    lng: 78.141,
  },
  {
    id: "1145",
    name: "Mukerian",
    state: "Punjab",
    lat: 31.9489,
    lng: 75.4472,
  },
  {
    id: "1146",
    name: "Sirsi",
    state: "Uttar Pradesh",
    lat: 25.9469,
    lng: 81.8642,
  },
  {
    id: "1147",
    name: "Purwa",
    state: "Uttar Pradesh",
    lat: 26.1391,
    lng: 81.8934,
  },
  {
    id: "1148",
    name: "Sheohar",
    state: "Bihar",
    lat: 26.4812,
    lng: 85.3066,
  },
  {
    id: "1149",
    name: "Namagiripettai",
    state: "Tamil Nadu",
    lat: 11.4196,
    lng: 78.0214,
  },
  {
    id: "1150",
    name: "Parasi",
    state: "Uttar Pradesh",
    lat: 26.7333,
    lng: 82.3667,
  },
  {
    id: "1151",
    name: "Lathi",
    state: "Gujarat",
    lat: 21.5361,
    lng: 71.7675,
  },
  {
    id: "1152",
    name: "Lalganj",
    state: "Uttar Pradesh",
    lat: 25.9919,
    lng: 82.4671,
  },
  {
    id: "1153",
    name: "Narkhed",
    state: "Maharashtra",
    lat: 21.2478,
    lng: 78.9214,
  },
  {
    id: "1154",
    name: "Mathabhanga",
    state: "West Bengal",
    lat: 26.3622,
    lng: 89.7794,
  },
  {
    id: "1155",
    name: "Shendurjana",
    state: "Maharashtra",
    lat: 20.95,
    lng: 78.3833,
  },
  {
    id: "1156",
    name: "Peravurani",
    state: "Tamil Nadu",
    lat: 10.2526,
    lng: 79.3127,
  },
  {
    id: "1157",
    name: "Mariani",
    state: "Assam",
    lat: 27.0333,
    lng: 95.5667,
  },
  {
    id: "1158",
    name: "Phulpur",
    state: "Uttar Pradesh",
    lat: 25.5086,
    lng: 82.1332,
  },
  {
    id: "1159",
    name: "Rania",
    state: "Haryana",
    lat: 29.9494,
    lng: 75.3892,
  },
  {
    id: "1160",
    name: "Pali",
    state: "Madhya Pradesh",
    lat: 24.2,
    lng: 79.9999,
  },
  {
    id: "1161",
    name: "Pachore",
    state: "Madhya Pradesh",
    lat: 23.9333,
    lng: 76.9167,
  },
  {
    id: "1162",
    name: "Parangipettai",
    state: "Tamil Nadu",
    lat: 11.5,
    lng: 79.6833,
  },
  {
    id: "1163",
    name: "Pudupattinam",
    state: "Tamil Nadu",
    lat: 11.3471,
    lng: 79.7839,
  },
  {
    id: "1164",
    name: "Panniyannur",
    state: "Kerala",
    lat: 11.9439,
    lng: 75.4872,
  },
  {
    id: "1165",
    name: "Maharajganj",
    state: "Bihar",
    lat: 26.7375,
    lng: 83.2226,
  },
  {
    id: "1166",
    name: "Rau",
    state: "Madhya Pradesh",
    lat: 22.7264,
    lng: 75.7597,
  },
  {
    id: "1167",
    name: "Monoharpur",
    state: "West Bengal",
    lat: 22.9685,
    lng: 87.5999,
  },
  {
    id: "1168",
    name: "Mandawa",
    state: "Rajasthan",
    lat: 27.9333,
    lng: 75.05,
  },
  {
    id: "1169",
    name: "Marigaon",
    state: "Assam",
    lat: 26.2327,
    lng: 92.3565,
  },
  {
    id: "1170",
    name: "Pallikonda",
    state: "Tamil Nadu",
    lat: 11.35,
    lng: 78.1,
  },
  {
    id: "1171",
    name: "Pindwara",
    state: "Rajasthan",
    lat: 24.99,
    lng: 73.23,
  },
  {
    id: "1172",
    name: "Shishgarh",
    state: "Uttar Pradesh",
    lat: 28.7532,
    lng: 79.6119,
  },
  {
    id: "1173",
    name: "Patur",
    state: "Maharashtra",
    lat: 20.7712,
    lng: 76.4444,
  },
  {
    id: "1174",
    name: "Mayang Imphal",
    state: "Manipur",
    lat: 24.6157,
    lng: 93.8899,
  },
  {
    id: "1175",
    name: "Mhowgaon",
    state: "Madhya Pradesh",
    lat: 22.5707,
    lng: 75.8404,
  },
  {
    id: "1176",
    name: "Guruvayoor",
    state: "Kerala",
    lat: 10.59,
    lng: 76.04,
  },
  {
    id: "1177",
    name: "Mhaswad",
    state: "Maharashtra",
    lat: 17.84,
    lng: 75.43,
  },
  {
    id: "1178",
    name: "Sahawar",
    state: "Uttar Pradesh",
    lat: 27.021,
    lng: 78.3337,
  },
  {
    id: "1179",
    name: "Sivagiri",
    state: "Tamil Nadu",
    lat: 9.3493,
    lng: 77.49,
  },
  {
    id: "1180",
    name: "Mundargi",
    state: "Karnataka",
    lat: 15.54,
    lng: 75.44,
  },
  {
    id: "1181",
    name: "Punjaipugalur",
    state: "Tamil Nadu",
    lat: 11.38,
    lng: 79.53,
  },
  {
    id: "1182",
    name: "Kailasahar",
    state: "Tripura",
    lat: 24.31,
    lng: 92.02,
  },
  {
    id: "1183",
    name: "Samthar",
    state: "Uttar Pradesh",
    lat: 25.43,
    lng: 79.41,
  },
  {
    id: "1184",
    name: "Sakti",
    state: "Chhattisgarh",
    lat: 22.03,
    lng: 82.66,
  },
  {
    id: "1185",
    name: "Sadalagi",
    state: "Karnataka",
    lat: 16.21,
    lng: 75.67,
  },
  {
    id: "1186",
    name: "Silao",
    state: "Bihar",
    lat: 25.18,
    lng: 85.37,
  },
  {
    id: "1187",
    name: "Mandalgarh",
    state: "Rajasthan",
    lat: 24.58,
    lng: 75.2,
  },
  {
    id: "1188",
    name: "Loha",
    state: "Maharashtra",
    lat: 19.66,
    lng: 78.75,
  },
  {
    id: "1189",
    name: "Pukhrayan",
    state: "Uttar Pradesh",
    lat: 26.14,
    lng: 79.8,
  },
  {
    id: "1190",
    name: "Padmanabhapuram",
    state: "Tamil Nadu",
    lat: 8.21,
    lng: 77.34,
  },
  {
    id: "1191",
    name: "Belonia",
    state: "Tripura",
    lat: 23.08,
    lng: 91.82,
  },
  {
    id: "1192",
    name: "Saiha",
    state: "Mizoram",
    lat: 22.97,
    lng: 92.67,
  },
  {
    id: "1193",
    name: "Srirampore",
    state: "West Bengal",
    lat: 22.75,
    lng: 88.34,
  },
  {
    id: "1194",
    name: "Talwara",
    state: "Punjab",
    lat: 31.57,
    lng: 75.28,
  },
  {
    id: "1195",
    name: "Puthuppally",
    state: "Kerala",
    lat: 9.57,
    lng: 76.57,
  },
  {
    id: "1196",
    name: "Khowai",
    state: "Tripura",
    lat: 24.32,
    lng: 91.51,
  },
  {
    id: "1197",
    name: "Vijaypur",
    state: "Madhya Pradesh",
    lat: 23.88,
    lng: 77.56,
  },
  {
    id: "1198",
    name: "Takhatgarh",
    state: "Rajasthan",
    lat: 25.08,
    lng: 74.88,
  },
  {
    id: "1199",
    name: "Thirupuvanam",
    state: "Tamil Nadu",
    lat: 9.82,
    lng: 78.45,
  },
  {
    id: "1200",
    name: "Adra",
    state: "West Bengal",
    lat: 23.62,
    lng: 86.74,
  },
  {
    id: "1201",
    name: "Piriyapatna",
    state: "Karnataka",
    lat: 12.31,
    lng: 76.16,
  },
  {
    id: "1202",
    name: "Obra",
    state: "Uttar Pradesh",
    lat: 25.58,
    lng: 82.9,
  },
  {
    id: "1203",
    name: "Adalaj",
    state: "Gujarat",
    lat: 23.13,
    lng: 72.53,
  },
  {
    id: "1204",
    name: "Nandgaon",
    state: "Maharashtra",
    lat: 20.44,
    lng: 75.07,
  },
  {
    id: "1205",
    name: "Barh",
    state: "Bihar",
    lat: 25.41,
    lng: 85.93,
  },
  {
    id: "1206",
    name: "Chhapra",
    state: "Gujarat",
    lat: 25.79,
    lng: 84.73,
  },
  {
    id: "1207",
    name: "Panamattom",
    state: "Kerala",
    lat: 9.64,
    lng: 76.82,
  },
  {
    id: "1208",
    name: "Niwai",
    state: "Uttar Pradesh",
    lat: 26.07,
    lng: 78.67,
  },
  {
    id: "1209",
    name: "Bageshwar",
    state: "Uttarakhand",
    lat: 29.85,
    lng: 79.9,
  },
  {
    id: "1210",
    name: "Tarbha",
    state: "Odisha",
    lat: 21.05,
    lng: 83.29,
  },
  {
    id: "1211",
    name: "Adyar",
    state: "Karnataka",
    lat: 13.17,
    lng: 77.57,
  },
  {
    id: "1212",
    name: "Narsinghgarh",
    state: "Madhya Pradesh",
    lat: 23.91,
    lng: 77.16,
  },
  {
    id: "1213",
    name: "Warud",
    state: "Maharashtra",
    lat: 21.35,
    lng: 78.92,
  },
  {
    id: "1214",
    name: "Asarganj",
    state: "Bihar",
    lat: 25.59,
    lng: 86.4,
  },
  {
    id: "1215",
    name: "Sarsod",
    state: "Haryana",
    lat: 29.59,
    lng: 75.77,
  },
  {
    id: "1216",
    name: "Gandhinagar",
    state: "Gujarat",
    lat: 23.22,
    lng: 72.68,
  },
  {
    id: "1217",
    name: "Kullu",
    state: "Himachal Pradesh",
    lat: 31.96,
    lng: 77.11,
  },
  {
    id: "1218",
    name: "Manali",
    state: "Himachal Pradesh",
    lat: 32.24,
    lng: 77.19,
  },
  {
    id: "1219",
    name: "Mirzapur",
    state: "Uttar Pradesh",
    lat: 25.15,
    lng: 82.58,
  },
  {
    id: "1220",
    name: "Kota",
    state: "Rajasthan",
    lat: 25.18,
    lng: 75.83,
  },
  {
    id: "1221",
    name: "Dispur",
    state: "Assam",
    lat: 26.14,
    lng: 91.79,
  },
];
